import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** The `BigInt` scalar type represents non-fractional signed whole numeric values. */
  BigInt: { input: any; output: any; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: { input: any; output: any; }
  /** A custom scalar to handle Prisma Decimal type */
  Decimal: { input: any; output: any; }
  /** Json custom scalar type */
  Json: { input: any; output: any; }
};

export type AccountsWithCount = {
  __typename?: 'AccountsWithCount';
  count: Scalars['Int']['output'];
  data?: Maybe<Array<Maybe<Accounts>>>;
};

export type BlockWithCount = {
  __typename?: 'BlockWithCount';
  count: Scalars['Int']['output'];
  data?: Maybe<Array<Maybe<Block>>>;
};

export type EraWithCount = {
  __typename?: 'EraWithCount';
  count: Scalars['Int']['output'];
  data?: Maybe<Array<Maybe<Era>>>;
};

export type EventWithCount = {
  __typename?: 'EventWithCount';
  count: Scalars['Int']['output'];
  data?: Maybe<Array<Maybe<Events>>>;
};

export type ExtrinsicWithCount = {
  __typename?: 'ExtrinsicWithCount';
  count: Scalars['Int']['output'];
  data?: Maybe<Array<Maybe<Extrinsics>>>;
};

export type FilterResult = {
  __typename?: 'FilterResult';
  action?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  filterKey?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  network?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  result?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  state?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export enum FilterType {
  Block = 'block',
  Extrinsics = 'extrinsics',
  Members = 'members',
  Shards = 'shards',
  Tasks = 'tasks',
  Transfer = 'transfer'
}

export type GmpMessage = {
  __typename?: 'GMPMessage';
  SubmitGatewayEventTask?: Maybe<SubmitGatewayEventTask>;
  SubmitGatewayEventTaskId?: Maybe<Scalars['Int']['output']>;
  assignedBatchId?: Maybe<Scalars['Int']['output']>;
  created_at: Scalars['DateTime']['output'];
  destBlockNumber?: Maybe<Scalars['String']['output']>;
  destEventLog?: Maybe<Scalars['Json']['output']>;
  destNetwork?: Maybe<Scalars['String']['output']>;
  destTransactionHash?: Maybe<Scalars['String']['output']>;
  destinationAddress?: Maybe<Scalars['String']['output']>;
  messageExecutedTaskId?: Maybe<Scalars['Int']['output']>;
  messageId: Scalars['ID']['output'];
  messageReceivedTaskId?: Maybe<Scalars['Int']['output']>;
  srcAddress?: Maybe<Scalars['String']['output']>;
  srcBlockNumber?: Maybe<Scalars['String']['output']>;
  srcEventLog?: Maybe<Scalars['Json']['output']>;
  srcNetwork?: Maybe<Scalars['String']['output']>;
  srcTransactionHash?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
  verified?: Maybe<Scalars['String']['output']>;
};

export type GmpMessagesWithCount = {
  __typename?: 'GMPMessagesWithCount';
  count: Scalars['Int']['output'];
  data?: Maybe<Array<Maybe<GmpMessage>>>;
};

export type LogWithCount = {
  __typename?: 'LogWithCount';
  count: Scalars['Int']['output'];
  data?: Maybe<Array<Maybe<Logs>>>;
};

export type MembersWithCount = {
  __typename?: 'MembersWithCount';
  count: Scalars['Int']['output'];
  data?: Maybe<Array<Maybe<Members>>>;
};

export type NominationsWithCount = {
  __typename?: 'NominationsWithCount';
  count: Scalars['Int']['output'];
  data?: Maybe<Array<Maybe<Nominations>>>;
};

export type Query = {
  __typename?: 'Query';
  GMPMessagesDetails: GmpMessage;
  SubmitGatewayTaskDetails: SubmitGatewayEventTask;
  accountDetails: Accounts;
  blockDetails?: Maybe<Block>;
  extrinsicDetails?: Maybe<Extrinsics>;
  filter: FilterResult;
  getEra?: Maybe<EraWithCount>;
  getExtrinsics: ExtrinsicWithCount;
  getNominators?: Maybe<NominationsWithCount>;
  getStakingReward?: Maybe<StakingRewardWithCount>;
  getValidators?: Maybe<GetValidatorsWithCount>;
  healthCheck?: Maybe<Scalars['Json']['output']>;
  listAccounts: AccountsWithCount;
  listBlocks: BlockWithCount;
  listEvents: EventWithCount;
  listExtrinsics: ExtrinsicWithCount;
  listGMPMessages: GmpMessagesWithCount;
  listLogs?: Maybe<LogWithCount>;
  listMembers: MembersWithCount;
  listShards: ShradWithCount;
  listSubmitGatewayEventsTask: SubmitGatewayEventsTasksWithCount;
  listTasks: ReadTaskWithCount;
  listValidators: ValidatorsWithCount;
  memberDetails: Members;
  nominatorDetails?: Maybe<Nominators>;
  search: Array<SearchResult>;
  searchEvent?: Maybe<SearchEventType>;
  shardDetails?: Maybe<Shards>;
  stakingTelemetry?: Maybe<Staking>;
  supportedChains?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  taskDetails: ReadGatewayEventsTask;
  telemetry: Telemetry;
  tokenDistribution?: Maybe<TokenIssuance>;
  transfersList?: Maybe<TransfersWithCount>;
  validatorDetails?: Maybe<Validators>;
};


export type QueryGmpMessagesDetailsArgs = {
  messageId: Scalars['String']['input'];
  sessionKey?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySubmitGatewayTaskDetailsArgs = {
  batchId?: InputMaybe<Scalars['Int']['input']>;
  sessionKey?: InputMaybe<Scalars['String']['input']>;
  taskId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAccountDetailsArgs = {
  publicAddress: Scalars['String']['input'];
  sessionKey?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBlockDetailsArgs = {
  blockHash?: InputMaybe<Scalars['String']['input']>;
  blockNumber?: InputMaybe<Scalars['Int']['input']>;
  sessionKey?: InputMaybe<Scalars['String']['input']>;
};


export type QueryExtrinsicDetailsArgs = {
  eventId?: InputMaybe<Scalars['String']['input']>;
  extrinsicHash?: InputMaybe<Scalars['String']['input']>;
  extrinsicId?: InputMaybe<Scalars['String']['input']>;
  sessionKey?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFilterArgs = {
  filterType: FilterType;
  sessionKey?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetEraArgs = {
  page?: InputMaybe<PageInputType>;
  sessionKey?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortInputType>;
  validator?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetExtrinsicsArgs = {
  blockNumber?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<PageInputType>;
  sessionKey?: InputMaybe<Scalars['String']['input']>;
  signer?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortInputType>;
};


export type QueryGetNominatorsArgs = {
  page?: InputMaybe<PageInputType>;
  sessionKey?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortInputType>;
  validator: Scalars['String']['input'];
};


export type QueryGetStakingRewardArgs = {
  page?: InputMaybe<PageInputType>;
  sessionKey?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortInputType>;
  validator?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetValidatorsArgs = {
  nominator: Scalars['String']['input'];
  page?: InputMaybe<PageInputType>;
  sessionKey?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortInputType>;
};


export type QueryHealthCheckArgs = {
  sessionKey?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListAccountsArgs = {
  page?: InputMaybe<PageInputType>;
  sessionKey?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortInputType>;
};


export type QueryListBlocksArgs = {
  filter?: InputMaybe<FilterInputType>;
  page?: InputMaybe<PageInputType>;
  sessionKey?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortInputType>;
};


export type QueryListEventsArgs = {
  blockNumber?: InputMaybe<Scalars['String']['input']>;
  extrinsicId?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<PageInputType>;
  sessionKey?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListExtrinsicsArgs = {
  filter?: InputMaybe<FilterInputType>;
  page?: InputMaybe<PageInputType>;
  sessionKey?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortInputType>;
};


export type QueryListGmpMessagesArgs = {
  destTransactionHash?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterInputType>;
  messageId?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<PageInputType>;
  phase?: InputMaybe<Scalars['String']['input']>;
  sessionKey?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortInputType>;
  srcTransactionHash?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListLogsArgs = {
  blockNumber?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<PageInputType>;
  sessionKey?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortInputType>;
};


export type QueryListMembersArgs = {
  filter?: InputMaybe<FilterInputType>;
  page?: InputMaybe<PageInputType>;
  sessionKey?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortInputType>;
};


export type QueryListShardsArgs = {
  filter?: InputMaybe<FilterInputType>;
  page?: InputMaybe<PageInputType>;
  sessionKey?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortInputType>;
};


export type QueryListSubmitGatewayEventsTaskArgs = {
  batchId?: InputMaybe<Array<Scalars['Int']['input']>>;
  filter?: InputMaybe<FilterInputType>;
  page?: InputMaybe<PageInputType>;
  phase?: InputMaybe<Scalars['String']['input']>;
  sessionKey?: InputMaybe<Scalars['String']['input']>;
  shardId?: InputMaybe<Array<Scalars['Int']['input']>>;
  sort?: InputMaybe<SortInputType>;
  taskId?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryListTasksArgs = {
  filter?: InputMaybe<FilterInputType>;
  messageId?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<PageInputType>;
  phase?: InputMaybe<Scalars['String']['input']>;
  sessionKey?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortInputType>;
  taskId?: InputMaybe<Array<Scalars['Int']['input']>>;
  taskType?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListValidatorsArgs = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<PageInputType>;
  sessionKey?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortInputType>;
};


export type QueryMemberDetailsArgs = {
  accountId: Scalars['String']['input'];
  sessionKey?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNominatorDetailsArgs = {
  address: Scalars['String']['input'];
  sessionKey?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchArgs = {
  searchTerm: Scalars['String']['input'];
  searchType: SearchType;
  sessionKey?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchEventArgs = {
  action?: InputMaybe<Scalars['String']['input']>;
  blockFrom?: InputMaybe<Scalars['Int']['input']>;
  blockNumber?: InputMaybe<Scalars['Int']['input']>;
  blockTo?: InputMaybe<Scalars['Int']['input']>;
  eventId?: InputMaybe<Scalars['String']['input']>;
  sessionKey?: InputMaybe<Scalars['String']['input']>;
};


export type QueryShardDetailsArgs = {
  ShardId: Scalars['String']['input'];
  sessionKey?: InputMaybe<Scalars['String']['input']>;
};


export type QueryStakingTelemetryArgs = {
  sessionKey?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySupportedChainsArgs = {
  sessionKey?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTaskDetailsArgs = {
  messageId?: InputMaybe<Scalars['String']['input']>;
  sessionKey?: InputMaybe<Scalars['String']['input']>;
  taskId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTelemetryArgs = {
  sessionKey?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTokenDistributionArgs = {
  sessionKey?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTransfersListArgs = {
  filter?: InputMaybe<FilterInputType>;
  isLargest?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<PageInputType>;
  publicAddress?: InputMaybe<Scalars['String']['input']>;
  sessionKey?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortInputType>;
};


export type QueryValidatorDetailsArgs = {
  address: Scalars['String']['input'];
  sessionKey?: InputMaybe<Scalars['String']['input']>;
};

export type ReadGatewayEventsTask = {
  __typename?: 'ReadGatewayEventsTask';
  created_at: Scalars['DateTime']['output'];
  definition?: Maybe<Scalars['Json']['output']>;
  executedMessageIds: Array<Scalars['String']['output']>;
  executedSubmitTaskId?: Maybe<Scalars['Int']['output']>;
  hasExecuted?: Maybe<Scalars['Boolean']['output']>;
  hasReceived?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  modified_at_block?: Maybe<Scalars['Int']['output']>;
  network?: Maybe<Scalars['String']['output']>;
  phase?: Maybe<Scalars['String']['output']>;
  proposed_at_block?: Maybe<Scalars['Int']['output']>;
  receivedMessageIds: Array<Scalars['String']['output']>;
  receivedSubmitTaskId?: Maybe<Scalars['Int']['output']>;
  result?: Maybe<Scalars['Json']['output']>;
  taskId: Scalars['Int']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type ReadTaskWithCount = {
  __typename?: 'ReadTaskWithCount';
  count: Scalars['Int']['output'];
  data?: Maybe<Array<Maybe<ReadGatewayEventsTask>>>;
};

export type SearchFilters = {
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  searchType?: InputMaybe<SearchType>;
};

export type SearchResult = GmpMessage | Validators | Accounts | Block | Events | Extrinsics | Members | Shards;

export enum SearchType {
  GmpMessage = 'GMPMessage',
  Validators = 'Validators',
  Accounts = 'accounts',
  All = 'all',
  Block = 'block',
  Events = 'events',
  Extrinsics = 'extrinsics',
  Members = 'members',
  Shards = 'shards'
}

export type ShradWithCount = {
  __typename?: 'ShradWithCount';
  count: Scalars['Int']['output'];
  data?: Maybe<Array<Maybe<Shards>>>;
};

export type StakingRewardWithCount = {
  __typename?: 'StakingRewardWithCount';
  count: Scalars['Int']['output'];
  data?: Maybe<Array<Maybe<StakingRewards>>>;
};

export type SubmitGatewayEventTask = {
  __typename?: 'SubmitGatewayEventTask';
  GMPMessage: Array<GmpMessage>;
  batchId?: Maybe<Scalars['Int']['output']>;
  batchTxHash?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  definition?: Maybe<Scalars['Json']['output']>;
  id: Scalars['Int']['output'];
  message?: Maybe<Scalars['Json']['output']>;
  modified_at_block?: Maybe<Scalars['Int']['output']>;
  network?: Maybe<Scalars['String']['output']>;
  phase?: Maybe<Scalars['String']['output']>;
  proposed_at_block?: Maybe<Scalars['Int']['output']>;
  result?: Maybe<Scalars['Json']['output']>;
  shardId?: Maybe<Scalars['Int']['output']>;
  taskId: Scalars['Int']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type SubmitGatewayEventsTasksWithCount = {
  __typename?: 'SubmitGatewayEventsTasksWithCount';
  count: Scalars['Int']['output'];
  data?: Maybe<Array<Maybe<SubmitGatewayEventTask>>>;
};

export type Subscription = {
  __typename?: 'Subscription';
  accountBalanceUpdated?: Maybe<AccountBalanceSubscriptionType>;
  newBlocks?: Maybe<BlockSubscriptionType>;
  newExtrinsics?: Maybe<Extrinsics>;
  newTelemetryData?: Maybe<Telemetry>;
  newTransfer?: Maybe<Transfers>;
};


export type SubscriptionAccountBalanceUpdatedArgs = {
  address: Scalars['String']['input'];
};


export type SubscriptionNewTransferArgs = {
  isLargest?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TokenIssuance = {
  __typename?: 'TokenIssuance';
  circulatingSupply?: Maybe<Scalars['Json']['output']>;
  totalIssuance?: Maybe<Scalars['String']['output']>;
  totalStaked?: Maybe<Scalars['Json']['output']>;
  treasury?: Maybe<Scalars['Json']['output']>;
  vesting?: Maybe<Scalars['Json']['output']>;
};

export type Validators = {
  __typename?: 'Validators';
  activeEra?: Maybe<Scalars['Int']['output']>;
  address: Scalars['ID']['output'];
  blocked: Scalars['String']['output'];
  commission: Scalars['String']['output'];
  controller?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  currentSession?: Maybe<Scalars['Int']['output']>;
  discoveredAt?: Maybe<Scalars['DateTime']['output']>;
  eraRewardPoints?: Maybe<Scalars['Float']['output']>;
  keys?: Maybe<Scalars['Json']['output']>;
  latestBlock?: Maybe<Scalars['Int']['output']>;
  nominatorCount?: Maybe<Scalars['String']['output']>;
  ownStake?: Maybe<Scalars['Float']['output']>;
  selfBonded?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<ValidatorsStatus>;
  totalBlocks?: Maybe<Scalars['Int']['output']>;
  totalBonded?: Maybe<Scalars['Float']['output']>;
  totalRewardPoints: Scalars['Float']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export enum ValidatorsStatus {
  Active = 'ACTIVE',
  Chilled = 'CHILLED',
  Inactive = 'INACTIVE',
  Kicked = 'KICKED',
  Offline = 'OFFLINE',
  Waiting = 'WAITING'
}

export type ValidatorsWithCount = {
  __typename?: 'ValidatorsWithCount';
  count: Scalars['Int']['output'];
  data?: Maybe<Array<Maybe<Validators>>>;
};

export type AccountBalanceSubscriptionType = {
  __typename?: 'accountBalanceSubscriptionType';
  balance: Scalars['String']['output'];
};

export type Accounts = {
  __typename?: 'accounts';
  address: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  data: Scalars['Json']['output'];
  extrinsicCount: Scalars['BigInt']['output'];
  publicAddress?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type Block = {
  __typename?: 'block';
  author?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  error: Scalars['Boolean']['output'];
  error_message?: Maybe<Scalars['String']['output']>;
  event_count?: Maybe<Scalars['Int']['output']>;
  extrinsic_count?: Maybe<Scalars['Int']['output']>;
  extrinsic_root: Scalars['String']['output'];
  hash: Scalars['String']['output'];
  nextBlock?: Maybe<Scalars['Int']['output']>;
  number: Scalars['Int']['output'];
  parent_hash?: Maybe<Scalars['String']['output']>;
  previousBlock?: Maybe<Scalars['Int']['output']>;
  state_root: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
};

export type BlockSubscriptionType = {
  __typename?: 'blockSubscriptionType';
  block?: Maybe<Block>;
  eventsCount?: Maybe<Scalars['Int']['output']>;
  extrinsicsCount?: Maybe<Scalars['Int']['output']>;
};

export type Era = {
  __typename?: 'era';
  blocksProduced?: Maybe<Scalars['Int']['output']>;
  endBlock?: Maybe<Scalars['BigInt']['output']>;
  era?: Maybe<Scalars['Int']['output']>;
  rewardPoints?: Maybe<Scalars['Int']['output']>;
  startBlock?: Maybe<Scalars['BigInt']['output']>;
};

export type Events = {
  __typename?: 'events';
  action: Scalars['String']['output'];
  data: Scalars['Json']['output'];
  eventId: Scalars['String']['output'];
  extrinsicHash: Scalars['String']['output'];
  extrinsicId: Scalars['String']['output'];
};

export type Extrinsics = {
  __typename?: 'extrinsics';
  args: Scalars['Json']['output'];
  assets_transfer?: Maybe<Scalars['String']['output']>;
  blockTime?: Maybe<Scalars['DateTime']['output']>;
  block_number: Scalars['Int']['output'];
  calls?: Maybe<Scalars['Json']['output']>;
  created_at: Scalars['DateTime']['output'];
  estimated_fee?: Maybe<Scalars['String']['output']>;
  failed_reason?: Maybe<Scalars['Json']['output']>;
  hash: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  life_time?: Maybe<Scalars['Json']['output']>;
  method: Scalars['String']['output'];
  nonce?: Maybe<Scalars['String']['output']>;
  result?: Maybe<Scalars['String']['output']>;
  section: Scalars['String']['output'];
  signature?: Maybe<Scalars['String']['output']>;
  signer?: Maybe<Scalars['String']['output']>;
  transferCount?: Maybe<Scalars['Int']['output']>;
  transfers?: Maybe<Array<Maybe<Transfers>>>;
  used_fee?: Maybe<Scalars['String']['output']>;
};

export type FilterInputType = {
  column?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type GetValidatorsType = {
  __typename?: 'getValidatorsType';
  active?: Maybe<Scalars['Boolean']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  commission?: Maybe<Scalars['String']['output']>;
  myShare?: Maybe<Scalars['String']['output']>;
  nominatorCount?: Maybe<Scalars['String']['output']>;
  selfBonded?: Maybe<Scalars['Float']['output']>;
  totalBonded?: Maybe<Scalars['Float']['output']>;
};

export type GetValidatorsWithCount = {
  __typename?: 'getValidatorsWithCount';
  count: Scalars['Int']['output'];
  data?: Maybe<Array<Maybe<GetValidatorsType>>>;
};

export type Logs = {
  __typename?: 'logs';
  block_number: Scalars['Int']['output'];
  data: Scalars['Json']['output'];
  engine: Scalars['String']['output'];
  index: Scalars['ID']['output'];
  type: Scalars['String']['output'];
};

export type Members = {
  __typename?: 'members';
  account_id: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  heartbeat?: Maybe<Scalars['Int']['output']>;
  modified_at_block?: Maybe<Scalars['Int']['output']>;
  network: Scalars['String']['output'];
  proposed_at_block?: Maybe<Scalars['Int']['output']>;
  shardId?: Maybe<Scalars['String']['output']>;
  sig: Scalars['String']['output'];
  state?: Maybe<Scalars['String']['output']>;
};

export type Nominations = {
  __typename?: 'nominations';
  nominatorAddress: Scalars['String']['output'];
  share?: Maybe<Scalars['String']['output']>;
  stakedAmount: Scalars['Float']['output'];
  validatorAddress: Scalars['String']['output'];
};

export type Nominators = {
  __typename?: 'nominators';
  address: Scalars['ID']['output'];
  bonded?: Maybe<Scalars['String']['output']>;
  controller?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type PageInputType = {
  number?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type SearchEventType = {
  __typename?: 'searchEventType';
  block?: Maybe<Block>;
  events?: Maybe<Array<Maybe<Events>>>;
  latestBlock?: Maybe<Block>;
};

export type Shards = {
  __typename?: 'shards';
  commitment?: Maybe<Scalars['Json']['output']>;
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  members: Array<Members>;
  modified_at_block?: Maybe<Scalars['Int']['output']>;
  network: Scalars['String']['output'];
  proposed_at_block: Scalars['Int']['output'];
  sig?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
};

export type SortInputType = {
  field?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<SortOrderType>;
};

export enum SortOrderType {
  Asc = 'asc',
  Desc = 'desc'
}

export type Staking = {
  __typename?: 'staking';
  activePools?: Maybe<Scalars['Int']['output']>;
  activeValidators?: Maybe<Scalars['Int']['output']>;
  epoch?: Maybe<Scalars['Int']['output']>;
  epochProgress?: Maybe<Scalars['Json']['output']>;
  era?: Maybe<Scalars['Int']['output']>;
  eraProgress?: Maybe<Scalars['Json']['output']>;
  minimumStake?: Maybe<Scalars['String']['output']>;
  nominatorStakeTotal?: Maybe<Scalars['String']['output']>;
  totalPools?: Maybe<Scalars['Int']['output']>;
  totalStake?: Maybe<Scalars['String']['output']>;
  totalValidators?: Maybe<Scalars['Int']['output']>;
  validatorStakeTotal?: Maybe<Scalars['String']['output']>;
};

export type StakingRewards = {
  __typename?: 'stakingRewards';
  action?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  era?: Maybe<Scalars['Int']['output']>;
  eventId: Scalars['ID']['output'];
  rewardAccount: Scalars['String']['output'];
  validatorStash: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type TaskSubscriptionType = {
  __typename?: 'taskSubscriptionType';
  task?: Maybe<ReadGatewayEventsTask>;
};

export type Telemetry = {
  __typename?: 'telemetry';
  active_members?: Maybe<Scalars['BigInt']['output']>;
  extrinsics?: Maybe<Scalars['BigInt']['output']>;
  finalized_blocks?: Maybe<Scalars['BigInt']['output']>;
  shards_live?: Maybe<Scalars['BigInt']['output']>;
  total_accounts?: Maybe<Scalars['BigInt']['output']>;
  total_gmpMessages?: Maybe<Scalars['BigInt']['output']>;
  transfers?: Maybe<Scalars['BigInt']['output']>;
};

export type Transfers = {
  __typename?: 'transfers';
  amount: Scalars['String']['output'];
  blockNumber: Scalars['Int']['output'];
  created_at?: Maybe<Scalars['DateTime']['output']>;
  extrinsicId: Scalars['String']['output'];
  extrinsicResult: Scalars['String']['output'];
  from: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  to: Scalars['String']['output'];
  transferred_amount?: Maybe<Scalars['Decimal']['output']>;
};

export type TransfersWithCount = {
  __typename?: 'transfersWithCount';
  count: Scalars['Int']['output'];
  data?: Maybe<Array<Maybe<Transfers>>>;
};

export type ListBlocksQueryVariables = Exact<{
  page?: InputMaybe<PageInputType>;
  sort?: InputMaybe<SortInputType>;
  sessionKey?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterInputType>;
}>;


export type ListBlocksQuery = { __typename?: 'Query', listBlocks: { __typename?: 'BlockWithCount', count: number, data?: Array<{ __typename?: 'block', number: number, hash: string, status?: string | null, author?: string | null, parent_hash?: string | null, extrinsic_root: string, event_count?: number | null, extrinsic_count?: number | null, created_at: any } | null> | null } };

export type ListBlocksWithExtrinsicsQueryVariables = Exact<{
  page?: InputMaybe<PageInputType>;
  sessionKey?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListBlocksWithExtrinsicsQuery = { __typename?: 'Query', listBlocks: { __typename?: 'BlockWithCount', count: number, data?: Array<{ __typename?: 'block', number: number, author?: string | null, created_at: any, extrinsic_count?: number | null, event_count?: number | null, status?: string | null } | null> | null } };

export type ListEventsQueryVariables = Exact<{
  extrinsicId?: InputMaybe<Scalars['String']['input']>;
  blockNumber?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<PageInputType>;
  sessionKey?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListEventsQuery = { __typename?: 'Query', listEvents: { __typename?: 'EventWithCount', count: number, data?: Array<{ __typename?: 'events', eventId: string, extrinsicId: string, extrinsicHash: string, action: string, data: any } | null> | null } };

export type ListExtrinsicsQueryVariables = Exact<{
  page?: InputMaybe<PageInputType>;
  sort?: InputMaybe<SortInputType>;
  sessionKey?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterInputType>;
}>;


export type ListExtrinsicsQuery = { __typename?: 'Query', listExtrinsics: { __typename?: 'ExtrinsicWithCount', count: number, data?: Array<{ __typename?: 'extrinsics', id: string, block_number: number, hash: string, result?: string | null, method: string, section: string, args: any, created_at: any } | null> | null } };

export type GetExtrinsicsQueryVariables = Exact<{
  page?: InputMaybe<PageInputType>;
  sort?: InputMaybe<SortInputType>;
  sessionKey?: InputMaybe<Scalars['String']['input']>;
  signer?: InputMaybe<Scalars['String']['input']>;
  blockNumber?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetExtrinsicsQuery = { __typename?: 'Query', getExtrinsics: { __typename?: 'ExtrinsicWithCount', count: number, data?: Array<{ __typename?: 'extrinsics', id: string, block_number: number, hash: string, result?: string | null, method: string, section: string, args: any, created_at: any } | null> | null } };

export type ListExtrinsicsForSubscriptionQueryVariables = Exact<{
  sessionKey?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListExtrinsicsForSubscriptionQuery = { __typename?: 'Query', listExtrinsics: { __typename?: 'ExtrinsicWithCount', data?: Array<{ __typename?: 'extrinsics', id: string, hash: string, method: string, created_at: any, result?: string | null } | null> | null } };

export type SearchQueryVariables = Exact<{
  searchType: SearchType;
  searchTerm: Scalars['String']['input'];
  sessionKey?: InputMaybe<Scalars['String']['input']>;
}>;


export type SearchQuery = { __typename?: 'Query', search: Array<{ __typename?: 'GMPMessage', GMPMessage_id: string, GMPMessage_hash?: string | null } | { __typename?: 'Validators', Validators_id: string } | { __typename?: 'accounts', accounts_id?: string | null, accounts_hash: string } | { __typename?: 'block', block_id: number, block_hash: string } | { __typename?: 'events', events_id: string } | { __typename?: 'extrinsics', extrinsics_id: string, extrinsics_hash: string } | { __typename?: 'members', members_id: string, members_hash: string } | { __typename?: 'shards', shards_id: string, shards_hash?: string | null }> };

export type FilterQueryVariables = Exact<{
  filterType: FilterType;
  sessionKey?: InputMaybe<Scalars['String']['input']>;
}>;


export type FilterQuery = { __typename?: 'Query', filter: { __typename?: 'FilterResult', filterKey?: Array<string | null> | null, status?: Array<string | null> | null, state?: Array<string | null> | null, network?: Array<string | null> | null, action?: Array<string | null> | null, result?: Array<string | null> | null } };

export type ListShardsQueryVariables = Exact<{
  sessionKey?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortInputType>;
  page?: InputMaybe<PageInputType>;
  filter?: InputMaybe<FilterInputType>;
}>;


export type ListShardsQuery = { __typename?: 'Query', listShards: { __typename?: 'ShradWithCount', count: number, data?: Array<{ __typename?: 'shards', id: string, state: string, sig?: string | null, commitment?: any | null, network: string, proposed_at_block: number, modified_at_block?: number | null } | null> | null } };

export type ShardDetailsQueryVariables = Exact<{
  shardId: Scalars['String']['input'];
  sessionKey?: InputMaybe<Scalars['String']['input']>;
}>;


export type ShardDetailsQuery = { __typename?: 'Query', shardDetails?: { __typename?: 'shards', id: string, state: string, sig?: string | null, commitment?: any | null, network: string, created_at: any, members: Array<{ __typename?: 'members', account_id: string }> } | null };

export type BlockDetailsQueryVariables = Exact<{
  sessionKey?: InputMaybe<Scalars['String']['input']>;
  blockNumber?: InputMaybe<Scalars['Int']['input']>;
  blockHash?: InputMaybe<Scalars['String']['input']>;
}>;


export type BlockDetailsQuery = { __typename?: 'Query', blockDetails?: { __typename?: 'block', number: number, hash: string, status?: string | null, author?: string | null, parent_hash?: string | null, extrinsic_root: string, state_root: string, created_at: any, error: boolean, error_message?: string | null, previousBlock?: number | null, nextBlock?: number | null } | null };

export type ListMembersQueryVariables = Exact<{
  page?: InputMaybe<PageInputType>;
  sort?: InputMaybe<SortInputType>;
  sessionKey?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterInputType>;
}>;


export type ListMembersQuery = { __typename?: 'Query', listMembers: { __typename?: 'MembersWithCount', count: number, data?: Array<{ __typename?: 'members', account_id: string, network: string, state?: string | null, sig: string, shardId?: string | null, heartbeat?: number | null, created_at: any } | null> | null } };

export type ExtrinsicDetailsQueryVariables = Exact<{
  extrinsicId?: InputMaybe<Scalars['String']['input']>;
  extrinsicHash?: InputMaybe<Scalars['String']['input']>;
  eventId?: InputMaybe<Scalars['String']['input']>;
  sessionKey?: InputMaybe<Scalars['String']['input']>;
}>;


export type ExtrinsicDetailsQuery = { __typename?: 'Query', extrinsicDetails?: { __typename?: 'extrinsics', id: string, block_number: number, created_at: any, life_time?: any | null, hash: string, signer?: string | null, estimated_fee?: string | null, signature?: string | null, used_fee?: string | null, assets_transfer?: string | null, nonce?: string | null, result?: string | null, args: any, section: string, method: string, failed_reason?: any | null, calls?: any | null, transferCount?: number | null, blockTime?: any | null, transfers?: Array<{ __typename?: 'transfers', id: number, from: string, to: string, amount: string } | null> | null } | null };

export type TelemetryQueryVariables = Exact<{
  sessionKey?: InputMaybe<Scalars['String']['input']>;
}>;


export type TelemetryQuery = { __typename?: 'Query', telemetry: { __typename?: 'telemetry', finalized_blocks?: any | null, active_members?: any | null, transfers?: any | null, shards_live?: any | null, total_gmpMessages?: any | null, total_accounts?: any | null, extrinsics?: any | null } };

export type SupportedChainsQueryVariables = Exact<{
  sessionKey?: InputMaybe<Scalars['String']['input']>;
}>;


export type SupportedChainsQuery = { __typename?: 'Query', supportedChains?: Array<string | null> | null };

export type ListValidatorsQueryVariables = Exact<{
  page?: InputMaybe<PageInputType>;
  sort?: InputMaybe<SortInputType>;
  sessionKey?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ListValidatorsQuery = { __typename?: 'Query', listValidators: { __typename?: 'ValidatorsWithCount', count: number, data?: Array<{ __typename?: 'Validators', address: string, commission: string, status?: ValidatorsStatus | null, eraRewardPoints?: number | null, totalRewardPoints: number, selfBonded?: number | null, totalBonded?: number | null, latestBlock?: number | null, nominatorCount?: string | null, discoveredAt?: any | null, updated_at: any } | null> | null } };

export type ValidatorDetailsQueryVariables = Exact<{
  address: Scalars['String']['input'];
  sessionKey?: InputMaybe<Scalars['String']['input']>;
}>;


export type ValidatorDetailsQuery = { __typename?: 'Query', validatorDetails?: { __typename?: 'Validators', address: string, controller?: string | null, commission: string, blocked: string, status?: ValidatorsStatus | null, eraRewardPoints?: number | null, totalRewardPoints: number, ownStake?: number | null, selfBonded?: number | null, totalBonded?: number | null, totalBlocks?: number | null, latestBlock?: number | null, activeEra?: number | null, currentSession?: number | null, keys?: any | null, nominatorCount?: string | null, discoveredAt?: any | null, created_at: any, updated_at: any } | null };

export type HealthCheckQueryVariables = Exact<{
  sessionKey?: InputMaybe<Scalars['String']['input']>;
}>;


export type HealthCheckQuery = { __typename?: 'Query', healthCheck?: any | null };

export type MemberDetailsQueryVariables = Exact<{
  accountId: Scalars['String']['input'];
  sessionKey?: InputMaybe<Scalars['String']['input']>;
}>;


export type MemberDetailsQuery = { __typename?: 'Query', memberDetails: { __typename?: 'members', account_id: string, heartbeat?: number | null, network: string, shardId?: string | null, sig: string, state?: string | null, created_at: any } };

export type ListAccountsQueryVariables = Exact<{
  page?: InputMaybe<PageInputType>;
  sort?: InputMaybe<SortInputType>;
  sessionKey?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListAccountsQuery = { __typename?: 'Query', listAccounts: { __typename?: 'AccountsWithCount', count: number, data?: Array<{ __typename?: 'accounts', address: string, publicAddress?: string | null, data: any, created_at: any, updated_at: any, extrinsicCount: any } | null> | null } };

export type AccountDetailsQueryVariables = Exact<{
  publicAddress: Scalars['String']['input'];
  sessionKey?: InputMaybe<Scalars['String']['input']>;
}>;


export type AccountDetailsQuery = { __typename?: 'Query', accountDetails: { __typename?: 'accounts', address: string, publicAddress?: string | null, data: any, created_at: any, updated_at: any } };

export type TransfersListQueryVariables = Exact<{
  isLargest?: InputMaybe<Scalars['Boolean']['input']>;
  sessionKey?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterInputType>;
  publicAddress?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<PageInputType>;
  sort?: InputMaybe<SortInputType>;
}>;


export type TransfersListQuery = { __typename?: 'Query', transfersList?: { __typename?: 'transfersWithCount', count: number, data?: Array<{ __typename?: 'transfers', amount: string, extrinsicId: string, extrinsicResult: string, from: string, id: number, to: string, blockNumber: number, created_at?: any | null, transferred_amount?: any | null } | null> | null } | null };

export type TokenDistributionQueryVariables = Exact<{
  sessionKey?: InputMaybe<Scalars['String']['input']>;
}>;


export type TokenDistributionQuery = { __typename?: 'Query', tokenDistribution?: { __typename?: 'TokenIssuance', totalIssuance?: string | null, totalStaked?: any | null, treasury?: any | null, circulatingSupply?: any | null, vesting?: any | null } | null };

export type StakingTelemetryQueryVariables = Exact<{
  sessionKey?: InputMaybe<Scalars['String']['input']>;
}>;


export type StakingTelemetryQuery = { __typename?: 'Query', stakingTelemetry?: { __typename?: 'staking', minimumStake?: string | null, era?: number | null, eraProgress?: any | null, epoch?: number | null, epochProgress?: any | null, totalPools?: number | null, activePools?: number | null, totalStake?: string | null, validatorStakeTotal?: string | null, nominatorStakeTotal?: string | null, totalValidators?: number | null, activeValidators?: number | null } | null };

export type ListLogsQueryVariables = Exact<{
  sessionKey?: InputMaybe<Scalars['String']['input']>;
  blockNumber?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<PageInputType>;
  sort?: InputMaybe<SortInputType>;
}>;


export type ListLogsQuery = { __typename?: 'Query', listLogs?: { __typename?: 'LogWithCount', count: number, data?: Array<{ __typename?: 'logs', index: string, type: string, engine: string, block_number: number, data: any } | null> | null } | null };

export type NominatorDetailsQueryVariables = Exact<{
  address: Scalars['String']['input'];
  sessionKey?: InputMaybe<Scalars['String']['input']>;
}>;


export type NominatorDetailsQuery = { __typename?: 'Query', nominatorDetails?: { __typename?: 'nominators', address: string, bonded?: string | null, controller?: string | null, created_at?: any | null, updated_at?: any | null, status?: string | null } | null };

export type GetNominatorsQueryVariables = Exact<{
  validator: Scalars['String']['input'];
  page?: InputMaybe<PageInputType>;
  sort?: InputMaybe<SortInputType>;
  sessionKey?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetNominatorsQuery = { __typename?: 'Query', getNominators?: { __typename?: 'NominationsWithCount', count: number, data?: Array<{ __typename?: 'nominations', nominatorAddress: string, stakedAmount: number, share?: string | null } | null> | null } | null };

export type GetEraQueryVariables = Exact<{
  sessionKey?: InputMaybe<Scalars['String']['input']>;
  validator?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<PageInputType>;
  sort?: InputMaybe<SortInputType>;
}>;


export type GetEraQuery = { __typename?: 'Query', getEra?: { __typename?: 'EraWithCount', count: number, data?: Array<{ __typename?: 'era', era?: number | null, blocksProduced?: number | null, startBlock?: any | null, endBlock?: any | null, rewardPoints?: number | null } | null> | null } | null };

export type GetStakingRewardQueryVariables = Exact<{
  page?: InputMaybe<PageInputType>;
  sessionKey?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortInputType>;
  validator?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetStakingRewardQuery = { __typename?: 'Query', getStakingReward?: { __typename?: 'StakingRewardWithCount', count: number, data?: Array<{ __typename?: 'stakingRewards', eventId: string, action?: string | null, rewardAccount: string, validatorStash: string, era?: number | null, value?: string | null, created_at: any } | null> | null } | null };

export type GetValidatorsQueryVariables = Exact<{
  nominator: Scalars['String']['input'];
  page?: InputMaybe<PageInputType>;
  sort?: InputMaybe<SortInputType>;
  sessionKey?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetValidatorsQuery = { __typename?: 'Query', getValidators?: { __typename?: 'getValidatorsWithCount', count: number, data?: Array<{ __typename?: 'getValidatorsType', address?: string | null, selfBonded?: number | null, totalBonded?: number | null, nominatorCount?: string | null, commission?: string | null, myShare?: string | null, active?: boolean | null } | null> | null } | null };

export type ListTasksQueryVariables = Exact<{
  page?: InputMaybe<PageInputType>;
  sort?: InputMaybe<SortInputType>;
  taskType?: InputMaybe<Scalars['String']['input']>;
  taskId?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  messageId?: InputMaybe<Scalars['String']['input']>;
  phase?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterInputType>;
  sessionKey?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListTasksQuery = { __typename?: 'Query', listTasks: { __typename?: 'ReadTaskWithCount', count: number, data?: Array<{ __typename?: 'ReadGatewayEventsTask', id: number, taskId: number, phase?: string | null, definition?: any | null, network?: string | null, hasReceived?: boolean | null, hasExecuted?: boolean | null, receivedMessageIds: Array<string>, executedMessageIds: Array<string>, receivedSubmitTaskId?: number | null, executedSubmitTaskId?: number | null, result?: any | null, proposed_at_block?: number | null, modified_at_block?: number | null, created_at: any, updated_at: any } | null> | null } };

export type TaskDetailsQueryVariables = Exact<{
  taskId?: InputMaybe<Scalars['Int']['input']>;
  messageId?: InputMaybe<Scalars['String']['input']>;
  sessionKey?: InputMaybe<Scalars['String']['input']>;
}>;


export type TaskDetailsQuery = { __typename?: 'Query', taskDetails: { __typename?: 'ReadGatewayEventsTask', id: number, taskId: number, phase?: string | null, definition?: any | null, network?: string | null, hasReceived?: boolean | null, hasExecuted?: boolean | null, receivedMessageIds: Array<string>, executedMessageIds: Array<string>, receivedSubmitTaskId?: number | null, executedSubmitTaskId?: number | null, result?: any | null, proposed_at_block?: number | null, modified_at_block?: number | null, created_at: any, updated_at: any } };

export type ListGmpMessagesQueryVariables = Exact<{
  page?: InputMaybe<PageInputType>;
  sort?: InputMaybe<SortInputType>;
  srcTransactionHash?: InputMaybe<Scalars['String']['input']>;
  destTransactionHash?: InputMaybe<Scalars['String']['input']>;
  messageId?: InputMaybe<Scalars['String']['input']>;
  phase?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterInputType>;
  sessionKey?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListGmpMessagesQuery = { __typename?: 'Query', listGMPMessages: { __typename?: 'GMPMessagesWithCount', count: number, data?: Array<{ __typename?: 'GMPMessage', messageId: string, srcAddress?: string | null, srcBlockNumber?: string | null, srcTransactionHash?: string | null, srcNetwork?: string | null, srcEventLog?: any | null, messageReceivedTaskId?: number | null, messageExecutedTaskId?: number | null, SubmitGatewayEventTaskId?: number | null, assignedBatchId?: number | null, status?: string | null, verified?: string | null, destBlockNumber?: string | null, destNetwork?: string | null, destTransactionHash?: string | null, destinationAddress?: string | null, destEventLog?: any | null, created_at: any, updated_at: any, SubmitGatewayEventTask?: { __typename?: 'SubmitGatewayEventTask', result?: any | null, batchTxHash?: string | null } | null } | null> | null } };

export type GmpMessagesDetailsQueryVariables = Exact<{
  messageId: Scalars['String']['input'];
  sessionKey?: InputMaybe<Scalars['String']['input']>;
}>;


export type GmpMessagesDetailsQuery = { __typename?: 'Query', GMPMessagesDetails: { __typename?: 'GMPMessage', messageId: string, srcAddress?: string | null, srcBlockNumber?: string | null, srcTransactionHash?: string | null, srcNetwork?: string | null, srcEventLog?: any | null, messageReceivedTaskId?: number | null, messageExecutedTaskId?: number | null, SubmitGatewayEventTaskId?: number | null, assignedBatchId?: number | null, status?: string | null, verified?: string | null, destBlockNumber?: string | null, destNetwork?: string | null, destTransactionHash?: string | null, destinationAddress?: string | null, destEventLog?: any | null, created_at: any, updated_at: any, SubmitGatewayEventTask?: { __typename?: 'SubmitGatewayEventTask', batchTxHash?: string | null } | null } };

export type ListSubmitGatewayEventsTaskQueryVariables = Exact<{
  page?: InputMaybe<PageInputType>;
  sort?: InputMaybe<SortInputType>;
  taskId?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  phase?: InputMaybe<Scalars['String']['input']>;
  batchId?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  shardId?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  filter?: InputMaybe<FilterInputType>;
  sessionKey?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListSubmitGatewayEventsTaskQuery = { __typename?: 'Query', listSubmitGatewayEventsTask: { __typename?: 'SubmitGatewayEventsTasksWithCount', count: number, data?: Array<{ __typename?: 'SubmitGatewayEventTask', id: number, taskId: number, phase?: string | null, definition?: any | null, network?: string | null, message?: any | null, result?: any | null, proposed_at_block?: number | null, modified_at_block?: number | null, created_at: any, updated_at: any, batchTxHash?: string | null, batchId?: number | null, shardId?: number | null } | null> | null } };

export type SubmitGatewayTaskDetailsQueryVariables = Exact<{
  taskId?: InputMaybe<Scalars['Int']['input']>;
  batchId?: InputMaybe<Scalars['Int']['input']>;
  sessionKey?: InputMaybe<Scalars['String']['input']>;
}>;


export type SubmitGatewayTaskDetailsQuery = { __typename?: 'Query', SubmitGatewayTaskDetails: { __typename?: 'SubmitGatewayEventTask', id: number, taskId: number, phase?: string | null, definition?: any | null, network?: string | null, message?: any | null, result?: any | null, proposed_at_block?: number | null, modified_at_block?: number | null, created_at: any, updated_at: any, batchTxHash?: string | null, batchId?: number | null, shardId?: number | null, GMPMessage: Array<{ __typename?: 'GMPMessage', messageId: string, srcAddress?: string | null, srcBlockNumber?: string | null, srcTransactionHash?: string | null, srcNetwork?: string | null, messageReceivedTaskId?: number | null, messageExecutedTaskId?: number | null, assignedBatchId?: number | null, status?: string | null, verified?: string | null, destBlockNumber?: string | null, destNetwork?: string | null, destTransactionHash?: string | null, destinationAddress?: string | null, created_at: any, updated_at: any }> } };

export type NewBlocksSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type NewBlocksSubscription = { __typename?: 'Subscription', newBlocks?: { __typename?: 'blockSubscriptionType', block?: { __typename?: 'block', number: number, hash: string, status?: string | null, author?: string | null, parent_hash?: string | null, extrinsic_root: string, extrinsic_count?: number | null, event_count?: number | null, created_at: any } | null } | null };

export type NewExtrinsicsSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type NewExtrinsicsSubscription = { __typename?: 'Subscription', newExtrinsics?: { __typename?: 'extrinsics', id: string, hash: string, method: string, created_at: any, result?: string | null } | null };

export type NewTransferSubscriptionVariables = Exact<{
  isLargest?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type NewTransferSubscription = { __typename?: 'Subscription', newTransfer?: { __typename?: 'transfers', from: string, id: number, to: string, extrinsicId: string, extrinsicResult: string, blockNumber: number, amount: string, created_at?: any | null } | null };

export type NewTelemetrySubscriptionVariables = Exact<{ [key: string]: never; }>;


export type NewTelemetrySubscription = { __typename?: 'Subscription', newTelemetryData?: { __typename?: 'telemetry', finalized_blocks?: any | null, active_members?: any | null, transfers?: any | null, shards_live?: any | null, total_gmpMessages?: any | null, total_accounts?: any | null, extrinsics?: any | null } | null };

export type AccountBalanceUpdatedSubscriptionVariables = Exact<{
  address: Scalars['String']['input'];
}>;


export type AccountBalanceUpdatedSubscription = { __typename?: 'Subscription', accountBalanceUpdated?: { __typename?: 'accountBalanceSubscriptionType', balance: string } | null };


export const ListBlocksDocument = gql`
    query ListBlocks($page: pageInputType, $sort: sortInputType, $sessionKey: String, $filter: filterInputType) {
  listBlocks(page: $page, sort: $sort, sessionKey: $sessionKey, filter: $filter) {
    count
    data {
      number
      hash
      status
      author
      parent_hash
      extrinsic_root
      event_count
      extrinsic_count
      created_at
    }
  }
}
    `;

/**
 * __useListBlocksQuery__
 *
 * To run a query within a React component, call `useListBlocksQuery` and pass it any options that fit your needs.
 * When your component renders, `useListBlocksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListBlocksQuery({
 *   variables: {
 *      page: // value for 'page'
 *      sort: // value for 'sort'
 *      sessionKey: // value for 'sessionKey'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useListBlocksQuery(baseOptions?: Apollo.QueryHookOptions<ListBlocksQuery, ListBlocksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListBlocksQuery, ListBlocksQueryVariables>(ListBlocksDocument, options);
      }
export function useListBlocksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListBlocksQuery, ListBlocksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListBlocksQuery, ListBlocksQueryVariables>(ListBlocksDocument, options);
        }
export type ListBlocksQueryHookResult = ReturnType<typeof useListBlocksQuery>;
export type ListBlocksLazyQueryHookResult = ReturnType<typeof useListBlocksLazyQuery>;
export type ListBlocksQueryResult = Apollo.QueryResult<ListBlocksQuery, ListBlocksQueryVariables>;
export const ListBlocksWithExtrinsicsDocument = gql`
    query ListBlocksWithExtrinsics($page: pageInputType, $sessionKey: String) {
  listBlocks(page: $page, sessionKey: $sessionKey) {
    count
    data {
      number
      author
      created_at
      extrinsic_count
      event_count
      status
    }
  }
}
    `;

/**
 * __useListBlocksWithExtrinsicsQuery__
 *
 * To run a query within a React component, call `useListBlocksWithExtrinsicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListBlocksWithExtrinsicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListBlocksWithExtrinsicsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      sessionKey: // value for 'sessionKey'
 *   },
 * });
 */
export function useListBlocksWithExtrinsicsQuery(baseOptions?: Apollo.QueryHookOptions<ListBlocksWithExtrinsicsQuery, ListBlocksWithExtrinsicsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListBlocksWithExtrinsicsQuery, ListBlocksWithExtrinsicsQueryVariables>(ListBlocksWithExtrinsicsDocument, options);
      }
export function useListBlocksWithExtrinsicsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListBlocksWithExtrinsicsQuery, ListBlocksWithExtrinsicsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListBlocksWithExtrinsicsQuery, ListBlocksWithExtrinsicsQueryVariables>(ListBlocksWithExtrinsicsDocument, options);
        }
export type ListBlocksWithExtrinsicsQueryHookResult = ReturnType<typeof useListBlocksWithExtrinsicsQuery>;
export type ListBlocksWithExtrinsicsLazyQueryHookResult = ReturnType<typeof useListBlocksWithExtrinsicsLazyQuery>;
export type ListBlocksWithExtrinsicsQueryResult = Apollo.QueryResult<ListBlocksWithExtrinsicsQuery, ListBlocksWithExtrinsicsQueryVariables>;
export const ListEventsDocument = gql`
    query ListEvents($extrinsicId: String, $blockNumber: String, $page: pageInputType, $sessionKey: String) {
  listEvents(
    extrinsicId: $extrinsicId
    blockNumber: $blockNumber
    page: $page
    sessionKey: $sessionKey
  ) {
    count
    data {
      eventId
      extrinsicId
      extrinsicHash
      action
      data
    }
  }
}
    `;

/**
 * __useListEventsQuery__
 *
 * To run a query within a React component, call `useListEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListEventsQuery({
 *   variables: {
 *      extrinsicId: // value for 'extrinsicId'
 *      blockNumber: // value for 'blockNumber'
 *      page: // value for 'page'
 *      sessionKey: // value for 'sessionKey'
 *   },
 * });
 */
export function useListEventsQuery(baseOptions?: Apollo.QueryHookOptions<ListEventsQuery, ListEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListEventsQuery, ListEventsQueryVariables>(ListEventsDocument, options);
      }
export function useListEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListEventsQuery, ListEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListEventsQuery, ListEventsQueryVariables>(ListEventsDocument, options);
        }
export type ListEventsQueryHookResult = ReturnType<typeof useListEventsQuery>;
export type ListEventsLazyQueryHookResult = ReturnType<typeof useListEventsLazyQuery>;
export type ListEventsQueryResult = Apollo.QueryResult<ListEventsQuery, ListEventsQueryVariables>;
export const ListExtrinsicsDocument = gql`
    query ListExtrinsics($page: pageInputType, $sort: sortInputType, $sessionKey: String, $filter: filterInputType) {
  listExtrinsics(
    page: $page
    sort: $sort
    sessionKey: $sessionKey
    filter: $filter
  ) {
    count
    data {
      id
      block_number
      hash
      result
      method
      section
      args
      created_at
    }
  }
}
    `;

/**
 * __useListExtrinsicsQuery__
 *
 * To run a query within a React component, call `useListExtrinsicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListExtrinsicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListExtrinsicsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      sort: // value for 'sort'
 *      sessionKey: // value for 'sessionKey'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useListExtrinsicsQuery(baseOptions?: Apollo.QueryHookOptions<ListExtrinsicsQuery, ListExtrinsicsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListExtrinsicsQuery, ListExtrinsicsQueryVariables>(ListExtrinsicsDocument, options);
      }
export function useListExtrinsicsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListExtrinsicsQuery, ListExtrinsicsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListExtrinsicsQuery, ListExtrinsicsQueryVariables>(ListExtrinsicsDocument, options);
        }
export type ListExtrinsicsQueryHookResult = ReturnType<typeof useListExtrinsicsQuery>;
export type ListExtrinsicsLazyQueryHookResult = ReturnType<typeof useListExtrinsicsLazyQuery>;
export type ListExtrinsicsQueryResult = Apollo.QueryResult<ListExtrinsicsQuery, ListExtrinsicsQueryVariables>;
export const GetExtrinsicsDocument = gql`
    query GetExtrinsics($page: pageInputType, $sort: sortInputType, $sessionKey: String, $signer: String, $blockNumber: String) {
  getExtrinsics(
    page: $page
    sort: $sort
    sessionKey: $sessionKey
    signer: $signer
    blockNumber: $blockNumber
  ) {
    count
    data {
      id
      block_number
      hash
      result
      method
      section
      args
      created_at
    }
  }
}
    `;

/**
 * __useGetExtrinsicsQuery__
 *
 * To run a query within a React component, call `useGetExtrinsicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExtrinsicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExtrinsicsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      sort: // value for 'sort'
 *      sessionKey: // value for 'sessionKey'
 *      signer: // value for 'signer'
 *      blockNumber: // value for 'blockNumber'
 *   },
 * });
 */
export function useGetExtrinsicsQuery(baseOptions?: Apollo.QueryHookOptions<GetExtrinsicsQuery, GetExtrinsicsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExtrinsicsQuery, GetExtrinsicsQueryVariables>(GetExtrinsicsDocument, options);
      }
export function useGetExtrinsicsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExtrinsicsQuery, GetExtrinsicsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExtrinsicsQuery, GetExtrinsicsQueryVariables>(GetExtrinsicsDocument, options);
        }
export type GetExtrinsicsQueryHookResult = ReturnType<typeof useGetExtrinsicsQuery>;
export type GetExtrinsicsLazyQueryHookResult = ReturnType<typeof useGetExtrinsicsLazyQuery>;
export type GetExtrinsicsQueryResult = Apollo.QueryResult<GetExtrinsicsQuery, GetExtrinsicsQueryVariables>;
export const ListExtrinsicsForSubscriptionDocument = gql`
    query ListExtrinsicsForSubscription($sessionKey: String) {
  listExtrinsics(page: {number: 1, size: 10}, sessionKey: $sessionKey) {
    data {
      id
      hash
      method
      created_at
      result
    }
  }
}
    `;

/**
 * __useListExtrinsicsForSubscriptionQuery__
 *
 * To run a query within a React component, call `useListExtrinsicsForSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useListExtrinsicsForSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListExtrinsicsForSubscriptionQuery({
 *   variables: {
 *      sessionKey: // value for 'sessionKey'
 *   },
 * });
 */
export function useListExtrinsicsForSubscriptionQuery(baseOptions?: Apollo.QueryHookOptions<ListExtrinsicsForSubscriptionQuery, ListExtrinsicsForSubscriptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListExtrinsicsForSubscriptionQuery, ListExtrinsicsForSubscriptionQueryVariables>(ListExtrinsicsForSubscriptionDocument, options);
      }
export function useListExtrinsicsForSubscriptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListExtrinsicsForSubscriptionQuery, ListExtrinsicsForSubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListExtrinsicsForSubscriptionQuery, ListExtrinsicsForSubscriptionQueryVariables>(ListExtrinsicsForSubscriptionDocument, options);
        }
export type ListExtrinsicsForSubscriptionQueryHookResult = ReturnType<typeof useListExtrinsicsForSubscriptionQuery>;
export type ListExtrinsicsForSubscriptionLazyQueryHookResult = ReturnType<typeof useListExtrinsicsForSubscriptionLazyQuery>;
export type ListExtrinsicsForSubscriptionQueryResult = Apollo.QueryResult<ListExtrinsicsForSubscriptionQuery, ListExtrinsicsForSubscriptionQueryVariables>;
export const SearchDocument = gql`
    query Search($searchType: SearchType!, $searchTerm: String!, $sessionKey: String) {
  search(
    searchType: $searchType
    searchTerm: $searchTerm
    sessionKey: $sessionKey
  ) {
    ... on block {
      block_id: number
      block_hash: hash
    }
    ... on events {
      events_id: eventId
    }
    ... on extrinsics {
      extrinsics_id: id
      extrinsics_hash: hash
    }
    ... on shards {
      shards_id: id
      shards_hash: sig
    }
    ... on members {
      members_id: account_id
      members_hash: sig
    }
    ... on Validators {
      Validators_id: address
    }
    ... on accounts {
      accounts_id: publicAddress
      accounts_hash: address
    }
    ... on GMPMessage {
      GMPMessage_id: messageId
      GMPMessage_hash: srcTransactionHash
    }
  }
}
    `;

/**
 * __useSearchQuery__
 *
 * To run a query within a React component, call `useSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchQuery({
 *   variables: {
 *      searchType: // value for 'searchType'
 *      searchTerm: // value for 'searchTerm'
 *      sessionKey: // value for 'sessionKey'
 *   },
 * });
 */
export function useSearchQuery(baseOptions: Apollo.QueryHookOptions<SearchQuery, SearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchQuery, SearchQueryVariables>(SearchDocument, options);
      }
export function useSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchQuery, SearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchQuery, SearchQueryVariables>(SearchDocument, options);
        }
export type SearchQueryHookResult = ReturnType<typeof useSearchQuery>;
export type SearchLazyQueryHookResult = ReturnType<typeof useSearchLazyQuery>;
export type SearchQueryResult = Apollo.QueryResult<SearchQuery, SearchQueryVariables>;
export const FilterDocument = gql`
    query Filter($filterType: FilterType!, $sessionKey: String) {
  filter(filterType: $filterType, sessionKey: $sessionKey) {
    filterKey
    status
    state
    network
    action
    result
  }
}
    `;

/**
 * __useFilterQuery__
 *
 * To run a query within a React component, call `useFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilterQuery({
 *   variables: {
 *      filterType: // value for 'filterType'
 *      sessionKey: // value for 'sessionKey'
 *   },
 * });
 */
export function useFilterQuery(baseOptions: Apollo.QueryHookOptions<FilterQuery, FilterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilterQuery, FilterQueryVariables>(FilterDocument, options);
      }
export function useFilterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilterQuery, FilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilterQuery, FilterQueryVariables>(FilterDocument, options);
        }
export type FilterQueryHookResult = ReturnType<typeof useFilterQuery>;
export type FilterLazyQueryHookResult = ReturnType<typeof useFilterLazyQuery>;
export type FilterQueryResult = Apollo.QueryResult<FilterQuery, FilterQueryVariables>;
export const ListShardsDocument = gql`
    query ListShards($sessionKey: String, $sort: sortInputType, $page: pageInputType, $filter: filterInputType) {
  listShards(sessionKey: $sessionKey, page: $page, sort: $sort, filter: $filter) {
    count
    data {
      id
      state
      sig
      commitment
      network
      proposed_at_block
      modified_at_block
    }
  }
}
    `;

/**
 * __useListShardsQuery__
 *
 * To run a query within a React component, call `useListShardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListShardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListShardsQuery({
 *   variables: {
 *      sessionKey: // value for 'sessionKey'
 *      sort: // value for 'sort'
 *      page: // value for 'page'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useListShardsQuery(baseOptions?: Apollo.QueryHookOptions<ListShardsQuery, ListShardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListShardsQuery, ListShardsQueryVariables>(ListShardsDocument, options);
      }
export function useListShardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListShardsQuery, ListShardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListShardsQuery, ListShardsQueryVariables>(ListShardsDocument, options);
        }
export type ListShardsQueryHookResult = ReturnType<typeof useListShardsQuery>;
export type ListShardsLazyQueryHookResult = ReturnType<typeof useListShardsLazyQuery>;
export type ListShardsQueryResult = Apollo.QueryResult<ListShardsQuery, ListShardsQueryVariables>;
export const ShardDetailsDocument = gql`
    query ShardDetails($shardId: String!, $sessionKey: String) {
  shardDetails(ShardId: $shardId, sessionKey: $sessionKey) {
    id
    state
    sig
    commitment
    network
    created_at
    members {
      account_id
    }
  }
}
    `;

/**
 * __useShardDetailsQuery__
 *
 * To run a query within a React component, call `useShardDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useShardDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShardDetailsQuery({
 *   variables: {
 *      shardId: // value for 'shardId'
 *      sessionKey: // value for 'sessionKey'
 *   },
 * });
 */
export function useShardDetailsQuery(baseOptions: Apollo.QueryHookOptions<ShardDetailsQuery, ShardDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShardDetailsQuery, ShardDetailsQueryVariables>(ShardDetailsDocument, options);
      }
export function useShardDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShardDetailsQuery, ShardDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShardDetailsQuery, ShardDetailsQueryVariables>(ShardDetailsDocument, options);
        }
export type ShardDetailsQueryHookResult = ReturnType<typeof useShardDetailsQuery>;
export type ShardDetailsLazyQueryHookResult = ReturnType<typeof useShardDetailsLazyQuery>;
export type ShardDetailsQueryResult = Apollo.QueryResult<ShardDetailsQuery, ShardDetailsQueryVariables>;
export const BlockDetailsDocument = gql`
    query BlockDetails($sessionKey: String, $blockNumber: Int, $blockHash: String) {
  blockDetails(
    sessionKey: $sessionKey
    blockNumber: $blockNumber
    blockHash: $blockHash
  ) {
    number
    hash
    status
    author
    parent_hash
    extrinsic_root
    state_root
    created_at
    error
    error_message
    previousBlock
    nextBlock
  }
}
    `;

/**
 * __useBlockDetailsQuery__
 *
 * To run a query within a React component, call `useBlockDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlockDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlockDetailsQuery({
 *   variables: {
 *      sessionKey: // value for 'sessionKey'
 *      blockNumber: // value for 'blockNumber'
 *      blockHash: // value for 'blockHash'
 *   },
 * });
 */
export function useBlockDetailsQuery(baseOptions?: Apollo.QueryHookOptions<BlockDetailsQuery, BlockDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BlockDetailsQuery, BlockDetailsQueryVariables>(BlockDetailsDocument, options);
      }
export function useBlockDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BlockDetailsQuery, BlockDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BlockDetailsQuery, BlockDetailsQueryVariables>(BlockDetailsDocument, options);
        }
export type BlockDetailsQueryHookResult = ReturnType<typeof useBlockDetailsQuery>;
export type BlockDetailsLazyQueryHookResult = ReturnType<typeof useBlockDetailsLazyQuery>;
export type BlockDetailsQueryResult = Apollo.QueryResult<BlockDetailsQuery, BlockDetailsQueryVariables>;
export const ListMembersDocument = gql`
    query ListMembers($page: pageInputType, $sort: sortInputType, $sessionKey: String, $filter: filterInputType) {
  listMembers(page: $page, sort: $sort, sessionKey: $sessionKey, filter: $filter) {
    count
    data {
      account_id
      network
      state
      sig
      shardId
      heartbeat
      created_at
    }
  }
}
    `;

/**
 * __useListMembersQuery__
 *
 * To run a query within a React component, call `useListMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListMembersQuery({
 *   variables: {
 *      page: // value for 'page'
 *      sort: // value for 'sort'
 *      sessionKey: // value for 'sessionKey'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useListMembersQuery(baseOptions?: Apollo.QueryHookOptions<ListMembersQuery, ListMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListMembersQuery, ListMembersQueryVariables>(ListMembersDocument, options);
      }
export function useListMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListMembersQuery, ListMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListMembersQuery, ListMembersQueryVariables>(ListMembersDocument, options);
        }
export type ListMembersQueryHookResult = ReturnType<typeof useListMembersQuery>;
export type ListMembersLazyQueryHookResult = ReturnType<typeof useListMembersLazyQuery>;
export type ListMembersQueryResult = Apollo.QueryResult<ListMembersQuery, ListMembersQueryVariables>;
export const ExtrinsicDetailsDocument = gql`
    query ExtrinsicDetails($extrinsicId: String, $extrinsicHash: String, $eventId: String, $sessionKey: String) {
  extrinsicDetails(
    extrinsicId: $extrinsicId
    extrinsicHash: $extrinsicHash
    eventId: $eventId
    sessionKey: $sessionKey
  ) {
    id
    block_number
    created_at
    life_time
    hash
    signer
    estimated_fee
    signature
    used_fee
    assets_transfer
    nonce
    result
    args
    section
    method
    failed_reason
    calls
    transfers {
      id
      from
      to
      amount
    }
    transferCount
    blockTime
  }
}
    `;

/**
 * __useExtrinsicDetailsQuery__
 *
 * To run a query within a React component, call `useExtrinsicDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExtrinsicDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExtrinsicDetailsQuery({
 *   variables: {
 *      extrinsicId: // value for 'extrinsicId'
 *      extrinsicHash: // value for 'extrinsicHash'
 *      eventId: // value for 'eventId'
 *      sessionKey: // value for 'sessionKey'
 *   },
 * });
 */
export function useExtrinsicDetailsQuery(baseOptions?: Apollo.QueryHookOptions<ExtrinsicDetailsQuery, ExtrinsicDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExtrinsicDetailsQuery, ExtrinsicDetailsQueryVariables>(ExtrinsicDetailsDocument, options);
      }
export function useExtrinsicDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExtrinsicDetailsQuery, ExtrinsicDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExtrinsicDetailsQuery, ExtrinsicDetailsQueryVariables>(ExtrinsicDetailsDocument, options);
        }
export type ExtrinsicDetailsQueryHookResult = ReturnType<typeof useExtrinsicDetailsQuery>;
export type ExtrinsicDetailsLazyQueryHookResult = ReturnType<typeof useExtrinsicDetailsLazyQuery>;
export type ExtrinsicDetailsQueryResult = Apollo.QueryResult<ExtrinsicDetailsQuery, ExtrinsicDetailsQueryVariables>;
export const TelemetryDocument = gql`
    query Telemetry($sessionKey: String) {
  telemetry(sessionKey: $sessionKey) {
    finalized_blocks
    active_members
    transfers
    shards_live
    total_gmpMessages
    total_accounts
    extrinsics
  }
}
    `;

/**
 * __useTelemetryQuery__
 *
 * To run a query within a React component, call `useTelemetryQuery` and pass it any options that fit your needs.
 * When your component renders, `useTelemetryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTelemetryQuery({
 *   variables: {
 *      sessionKey: // value for 'sessionKey'
 *   },
 * });
 */
export function useTelemetryQuery(baseOptions?: Apollo.QueryHookOptions<TelemetryQuery, TelemetryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TelemetryQuery, TelemetryQueryVariables>(TelemetryDocument, options);
      }
export function useTelemetryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TelemetryQuery, TelemetryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TelemetryQuery, TelemetryQueryVariables>(TelemetryDocument, options);
        }
export type TelemetryQueryHookResult = ReturnType<typeof useTelemetryQuery>;
export type TelemetryLazyQueryHookResult = ReturnType<typeof useTelemetryLazyQuery>;
export type TelemetryQueryResult = Apollo.QueryResult<TelemetryQuery, TelemetryQueryVariables>;
export const SupportedChainsDocument = gql`
    query SupportedChains($sessionKey: String) {
  supportedChains(sessionKey: $sessionKey)
}
    `;

/**
 * __useSupportedChainsQuery__
 *
 * To run a query within a React component, call `useSupportedChainsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupportedChainsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupportedChainsQuery({
 *   variables: {
 *      sessionKey: // value for 'sessionKey'
 *   },
 * });
 */
export function useSupportedChainsQuery(baseOptions?: Apollo.QueryHookOptions<SupportedChainsQuery, SupportedChainsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SupportedChainsQuery, SupportedChainsQueryVariables>(SupportedChainsDocument, options);
      }
export function useSupportedChainsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SupportedChainsQuery, SupportedChainsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SupportedChainsQuery, SupportedChainsQueryVariables>(SupportedChainsDocument, options);
        }
export type SupportedChainsQueryHookResult = ReturnType<typeof useSupportedChainsQuery>;
export type SupportedChainsLazyQueryHookResult = ReturnType<typeof useSupportedChainsLazyQuery>;
export type SupportedChainsQueryResult = Apollo.QueryResult<SupportedChainsQuery, SupportedChainsQueryVariables>;
export const ListValidatorsDocument = gql`
    query ListValidators($page: pageInputType, $sort: sortInputType, $sessionKey: String, $isActive: Boolean) {
  listValidators(
    page: $page
    sort: $sort
    sessionKey: $sessionKey
    isActive: $isActive
  ) {
    count
    data {
      address
      commission
      status
      eraRewardPoints
      totalRewardPoints
      selfBonded
      totalBonded
      latestBlock
      nominatorCount
      discoveredAt
      updated_at
    }
  }
}
    `;

/**
 * __useListValidatorsQuery__
 *
 * To run a query within a React component, call `useListValidatorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListValidatorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListValidatorsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      sort: // value for 'sort'
 *      sessionKey: // value for 'sessionKey'
 *      isActive: // value for 'isActive'
 *   },
 * });
 */
export function useListValidatorsQuery(baseOptions?: Apollo.QueryHookOptions<ListValidatorsQuery, ListValidatorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListValidatorsQuery, ListValidatorsQueryVariables>(ListValidatorsDocument, options);
      }
export function useListValidatorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListValidatorsQuery, ListValidatorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListValidatorsQuery, ListValidatorsQueryVariables>(ListValidatorsDocument, options);
        }
export type ListValidatorsQueryHookResult = ReturnType<typeof useListValidatorsQuery>;
export type ListValidatorsLazyQueryHookResult = ReturnType<typeof useListValidatorsLazyQuery>;
export type ListValidatorsQueryResult = Apollo.QueryResult<ListValidatorsQuery, ListValidatorsQueryVariables>;
export const ValidatorDetailsDocument = gql`
    query ValidatorDetails($address: String!, $sessionKey: String) {
  validatorDetails(address: $address, sessionKey: $sessionKey) {
    address
    controller
    commission
    blocked
    status
    eraRewardPoints
    totalRewardPoints
    ownStake
    selfBonded
    totalBonded
    totalBlocks
    latestBlock
    activeEra
    currentSession
    keys
    nominatorCount
    discoveredAt
    created_at
    updated_at
  }
}
    `;

/**
 * __useValidatorDetailsQuery__
 *
 * To run a query within a React component, call `useValidatorDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidatorDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidatorDetailsQuery({
 *   variables: {
 *      address: // value for 'address'
 *      sessionKey: // value for 'sessionKey'
 *   },
 * });
 */
export function useValidatorDetailsQuery(baseOptions: Apollo.QueryHookOptions<ValidatorDetailsQuery, ValidatorDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidatorDetailsQuery, ValidatorDetailsQueryVariables>(ValidatorDetailsDocument, options);
      }
export function useValidatorDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidatorDetailsQuery, ValidatorDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidatorDetailsQuery, ValidatorDetailsQueryVariables>(ValidatorDetailsDocument, options);
        }
export type ValidatorDetailsQueryHookResult = ReturnType<typeof useValidatorDetailsQuery>;
export type ValidatorDetailsLazyQueryHookResult = ReturnType<typeof useValidatorDetailsLazyQuery>;
export type ValidatorDetailsQueryResult = Apollo.QueryResult<ValidatorDetailsQuery, ValidatorDetailsQueryVariables>;
export const HealthCheckDocument = gql`
    query HealthCheck($sessionKey: String) {
  healthCheck(sessionKey: $sessionKey)
}
    `;

/**
 * __useHealthCheckQuery__
 *
 * To run a query within a React component, call `useHealthCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useHealthCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHealthCheckQuery({
 *   variables: {
 *      sessionKey: // value for 'sessionKey'
 *   },
 * });
 */
export function useHealthCheckQuery(baseOptions?: Apollo.QueryHookOptions<HealthCheckQuery, HealthCheckQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HealthCheckQuery, HealthCheckQueryVariables>(HealthCheckDocument, options);
      }
export function useHealthCheckLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HealthCheckQuery, HealthCheckQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HealthCheckQuery, HealthCheckQueryVariables>(HealthCheckDocument, options);
        }
export type HealthCheckQueryHookResult = ReturnType<typeof useHealthCheckQuery>;
export type HealthCheckLazyQueryHookResult = ReturnType<typeof useHealthCheckLazyQuery>;
export type HealthCheckQueryResult = Apollo.QueryResult<HealthCheckQuery, HealthCheckQueryVariables>;
export const MemberDetailsDocument = gql`
    query MemberDetails($accountId: String!, $sessionKey: String) {
  memberDetails(accountId: $accountId, sessionKey: $sessionKey) {
    account_id
    heartbeat
    network
    shardId
    sig
    state
    created_at
  }
}
    `;

/**
 * __useMemberDetailsQuery__
 *
 * To run a query within a React component, call `useMemberDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMemberDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMemberDetailsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      sessionKey: // value for 'sessionKey'
 *   },
 * });
 */
export function useMemberDetailsQuery(baseOptions: Apollo.QueryHookOptions<MemberDetailsQuery, MemberDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MemberDetailsQuery, MemberDetailsQueryVariables>(MemberDetailsDocument, options);
      }
export function useMemberDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MemberDetailsQuery, MemberDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MemberDetailsQuery, MemberDetailsQueryVariables>(MemberDetailsDocument, options);
        }
export type MemberDetailsQueryHookResult = ReturnType<typeof useMemberDetailsQuery>;
export type MemberDetailsLazyQueryHookResult = ReturnType<typeof useMemberDetailsLazyQuery>;
export type MemberDetailsQueryResult = Apollo.QueryResult<MemberDetailsQuery, MemberDetailsQueryVariables>;
export const ListAccountsDocument = gql`
    query ListAccounts($page: pageInputType, $sort: sortInputType, $sessionKey: String) {
  listAccounts(page: $page, sort: $sort, sessionKey: $sessionKey) {
    data {
      address
      publicAddress
      data
      created_at
      updated_at
      extrinsicCount
    }
    count
  }
}
    `;

/**
 * __useListAccountsQuery__
 *
 * To run a query within a React component, call `useListAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAccountsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      sort: // value for 'sort'
 *      sessionKey: // value for 'sessionKey'
 *   },
 * });
 */
export function useListAccountsQuery(baseOptions?: Apollo.QueryHookOptions<ListAccountsQuery, ListAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAccountsQuery, ListAccountsQueryVariables>(ListAccountsDocument, options);
      }
export function useListAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAccountsQuery, ListAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAccountsQuery, ListAccountsQueryVariables>(ListAccountsDocument, options);
        }
export type ListAccountsQueryHookResult = ReturnType<typeof useListAccountsQuery>;
export type ListAccountsLazyQueryHookResult = ReturnType<typeof useListAccountsLazyQuery>;
export type ListAccountsQueryResult = Apollo.QueryResult<ListAccountsQuery, ListAccountsQueryVariables>;
export const AccountDetailsDocument = gql`
    query AccountDetails($publicAddress: String!, $sessionKey: String) {
  accountDetails(publicAddress: $publicAddress, sessionKey: $sessionKey) {
    address
    publicAddress
    data
    created_at
    updated_at
  }
}
    `;

/**
 * __useAccountDetailsQuery__
 *
 * To run a query within a React component, call `useAccountDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountDetailsQuery({
 *   variables: {
 *      publicAddress: // value for 'publicAddress'
 *      sessionKey: // value for 'sessionKey'
 *   },
 * });
 */
export function useAccountDetailsQuery(baseOptions: Apollo.QueryHookOptions<AccountDetailsQuery, AccountDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountDetailsQuery, AccountDetailsQueryVariables>(AccountDetailsDocument, options);
      }
export function useAccountDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountDetailsQuery, AccountDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountDetailsQuery, AccountDetailsQueryVariables>(AccountDetailsDocument, options);
        }
export type AccountDetailsQueryHookResult = ReturnType<typeof useAccountDetailsQuery>;
export type AccountDetailsLazyQueryHookResult = ReturnType<typeof useAccountDetailsLazyQuery>;
export type AccountDetailsQueryResult = Apollo.QueryResult<AccountDetailsQuery, AccountDetailsQueryVariables>;
export const TransfersListDocument = gql`
    query TransfersList($isLargest: Boolean, $sessionKey: String, $filter: filterInputType, $publicAddress: String, $page: pageInputType, $sort: sortInputType) {
  transfersList(
    isLargest: $isLargest
    sessionKey: $sessionKey
    filter: $filter
    publicAddress: $publicAddress
    page: $page
    sort: $sort
  ) {
    data {
      amount
      extrinsicId
      extrinsicResult
      from
      id
      to
      blockNumber
      created_at
      transferred_amount
    }
    count
  }
}
    `;

/**
 * __useTransfersListQuery__
 *
 * To run a query within a React component, call `useTransfersListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransfersListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransfersListQuery({
 *   variables: {
 *      isLargest: // value for 'isLargest'
 *      sessionKey: // value for 'sessionKey'
 *      filter: // value for 'filter'
 *      publicAddress: // value for 'publicAddress'
 *      page: // value for 'page'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useTransfersListQuery(baseOptions?: Apollo.QueryHookOptions<TransfersListQuery, TransfersListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TransfersListQuery, TransfersListQueryVariables>(TransfersListDocument, options);
      }
export function useTransfersListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TransfersListQuery, TransfersListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TransfersListQuery, TransfersListQueryVariables>(TransfersListDocument, options);
        }
export type TransfersListQueryHookResult = ReturnType<typeof useTransfersListQuery>;
export type TransfersListLazyQueryHookResult = ReturnType<typeof useTransfersListLazyQuery>;
export type TransfersListQueryResult = Apollo.QueryResult<TransfersListQuery, TransfersListQueryVariables>;
export const TokenDistributionDocument = gql`
    query TokenDistribution($sessionKey: String) {
  tokenDistribution(sessionKey: $sessionKey) {
    totalIssuance
    totalStaked
    treasury
    circulatingSupply
    vesting
  }
}
    `;

/**
 * __useTokenDistributionQuery__
 *
 * To run a query within a React component, call `useTokenDistributionQuery` and pass it any options that fit your needs.
 * When your component renders, `useTokenDistributionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTokenDistributionQuery({
 *   variables: {
 *      sessionKey: // value for 'sessionKey'
 *   },
 * });
 */
export function useTokenDistributionQuery(baseOptions?: Apollo.QueryHookOptions<TokenDistributionQuery, TokenDistributionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TokenDistributionQuery, TokenDistributionQueryVariables>(TokenDistributionDocument, options);
      }
export function useTokenDistributionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TokenDistributionQuery, TokenDistributionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TokenDistributionQuery, TokenDistributionQueryVariables>(TokenDistributionDocument, options);
        }
export type TokenDistributionQueryHookResult = ReturnType<typeof useTokenDistributionQuery>;
export type TokenDistributionLazyQueryHookResult = ReturnType<typeof useTokenDistributionLazyQuery>;
export type TokenDistributionQueryResult = Apollo.QueryResult<TokenDistributionQuery, TokenDistributionQueryVariables>;
export const StakingTelemetryDocument = gql`
    query StakingTelemetry($sessionKey: String) {
  stakingTelemetry(sessionKey: $sessionKey) {
    minimumStake
    era
    eraProgress
    epoch
    epochProgress
    totalPools
    activePools
    totalStake
    validatorStakeTotal
    nominatorStakeTotal
    totalValidators
    activeValidators
  }
}
    `;

/**
 * __useStakingTelemetryQuery__
 *
 * To run a query within a React component, call `useStakingTelemetryQuery` and pass it any options that fit your needs.
 * When your component renders, `useStakingTelemetryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStakingTelemetryQuery({
 *   variables: {
 *      sessionKey: // value for 'sessionKey'
 *   },
 * });
 */
export function useStakingTelemetryQuery(baseOptions?: Apollo.QueryHookOptions<StakingTelemetryQuery, StakingTelemetryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StakingTelemetryQuery, StakingTelemetryQueryVariables>(StakingTelemetryDocument, options);
      }
export function useStakingTelemetryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StakingTelemetryQuery, StakingTelemetryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StakingTelemetryQuery, StakingTelemetryQueryVariables>(StakingTelemetryDocument, options);
        }
export type StakingTelemetryQueryHookResult = ReturnType<typeof useStakingTelemetryQuery>;
export type StakingTelemetryLazyQueryHookResult = ReturnType<typeof useStakingTelemetryLazyQuery>;
export type StakingTelemetryQueryResult = Apollo.QueryResult<StakingTelemetryQuery, StakingTelemetryQueryVariables>;
export const ListLogsDocument = gql`
    query ListLogs($sessionKey: String, $blockNumber: Int, $page: pageInputType, $sort: sortInputType) {
  listLogs(
    sessionKey: $sessionKey
    blockNumber: $blockNumber
    page: $page
    sort: $sort
  ) {
    data {
      index
      type
      engine
      block_number
      data
    }
    count
  }
}
    `;

/**
 * __useListLogsQuery__
 *
 * To run a query within a React component, call `useListLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListLogsQuery({
 *   variables: {
 *      sessionKey: // value for 'sessionKey'
 *      blockNumber: // value for 'blockNumber'
 *      page: // value for 'page'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useListLogsQuery(baseOptions?: Apollo.QueryHookOptions<ListLogsQuery, ListLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListLogsQuery, ListLogsQueryVariables>(ListLogsDocument, options);
      }
export function useListLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListLogsQuery, ListLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListLogsQuery, ListLogsQueryVariables>(ListLogsDocument, options);
        }
export type ListLogsQueryHookResult = ReturnType<typeof useListLogsQuery>;
export type ListLogsLazyQueryHookResult = ReturnType<typeof useListLogsLazyQuery>;
export type ListLogsQueryResult = Apollo.QueryResult<ListLogsQuery, ListLogsQueryVariables>;
export const NominatorDetailsDocument = gql`
    query NominatorDetails($address: String!, $sessionKey: String) {
  nominatorDetails(address: $address, sessionKey: $sessionKey) {
    address
    bonded
    controller
    created_at
    updated_at
    status
  }
}
    `;

/**
 * __useNominatorDetailsQuery__
 *
 * To run a query within a React component, call `useNominatorDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNominatorDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNominatorDetailsQuery({
 *   variables: {
 *      address: // value for 'address'
 *      sessionKey: // value for 'sessionKey'
 *   },
 * });
 */
export function useNominatorDetailsQuery(baseOptions: Apollo.QueryHookOptions<NominatorDetailsQuery, NominatorDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NominatorDetailsQuery, NominatorDetailsQueryVariables>(NominatorDetailsDocument, options);
      }
export function useNominatorDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NominatorDetailsQuery, NominatorDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NominatorDetailsQuery, NominatorDetailsQueryVariables>(NominatorDetailsDocument, options);
        }
export type NominatorDetailsQueryHookResult = ReturnType<typeof useNominatorDetailsQuery>;
export type NominatorDetailsLazyQueryHookResult = ReturnType<typeof useNominatorDetailsLazyQuery>;
export type NominatorDetailsQueryResult = Apollo.QueryResult<NominatorDetailsQuery, NominatorDetailsQueryVariables>;
export const GetNominatorsDocument = gql`
    query GetNominators($validator: String!, $page: pageInputType, $sort: sortInputType, $sessionKey: String) {
  getNominators(
    validator: $validator
    page: $page
    sort: $sort
    sessionKey: $sessionKey
  ) {
    count
    data {
      nominatorAddress
      stakedAmount
      share
    }
  }
}
    `;

/**
 * __useGetNominatorsQuery__
 *
 * To run a query within a React component, call `useGetNominatorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNominatorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNominatorsQuery({
 *   variables: {
 *      validator: // value for 'validator'
 *      page: // value for 'page'
 *      sort: // value for 'sort'
 *      sessionKey: // value for 'sessionKey'
 *   },
 * });
 */
export function useGetNominatorsQuery(baseOptions: Apollo.QueryHookOptions<GetNominatorsQuery, GetNominatorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNominatorsQuery, GetNominatorsQueryVariables>(GetNominatorsDocument, options);
      }
export function useGetNominatorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNominatorsQuery, GetNominatorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNominatorsQuery, GetNominatorsQueryVariables>(GetNominatorsDocument, options);
        }
export type GetNominatorsQueryHookResult = ReturnType<typeof useGetNominatorsQuery>;
export type GetNominatorsLazyQueryHookResult = ReturnType<typeof useGetNominatorsLazyQuery>;
export type GetNominatorsQueryResult = Apollo.QueryResult<GetNominatorsQuery, GetNominatorsQueryVariables>;
export const GetEraDocument = gql`
    query GetEra($sessionKey: String, $validator: String, $page: pageInputType, $sort: sortInputType) {
  getEra(sessionKey: $sessionKey, validator: $validator, page: $page, sort: $sort) {
    data {
      era
      blocksProduced
      startBlock
      endBlock
      rewardPoints
    }
    count
  }
}
    `;

/**
 * __useGetEraQuery__
 *
 * To run a query within a React component, call `useGetEraQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEraQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEraQuery({
 *   variables: {
 *      sessionKey: // value for 'sessionKey'
 *      validator: // value for 'validator'
 *      page: // value for 'page'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetEraQuery(baseOptions?: Apollo.QueryHookOptions<GetEraQuery, GetEraQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEraQuery, GetEraQueryVariables>(GetEraDocument, options);
      }
export function useGetEraLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEraQuery, GetEraQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEraQuery, GetEraQueryVariables>(GetEraDocument, options);
        }
export type GetEraQueryHookResult = ReturnType<typeof useGetEraQuery>;
export type GetEraLazyQueryHookResult = ReturnType<typeof useGetEraLazyQuery>;
export type GetEraQueryResult = Apollo.QueryResult<GetEraQuery, GetEraQueryVariables>;
export const GetStakingRewardDocument = gql`
    query GetStakingReward($page: pageInputType, $sessionKey: String, $sort: sortInputType, $validator: String) {
  getStakingReward(
    page: $page
    sessionKey: $sessionKey
    sort: $sort
    validator: $validator
  ) {
    data {
      eventId
      action
      rewardAccount
      validatorStash
      era
      value
      created_at
    }
    count
  }
}
    `;

/**
 * __useGetStakingRewardQuery__
 *
 * To run a query within a React component, call `useGetStakingRewardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStakingRewardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStakingRewardQuery({
 *   variables: {
 *      page: // value for 'page'
 *      sessionKey: // value for 'sessionKey'
 *      sort: // value for 'sort'
 *      validator: // value for 'validator'
 *   },
 * });
 */
export function useGetStakingRewardQuery(baseOptions?: Apollo.QueryHookOptions<GetStakingRewardQuery, GetStakingRewardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStakingRewardQuery, GetStakingRewardQueryVariables>(GetStakingRewardDocument, options);
      }
export function useGetStakingRewardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStakingRewardQuery, GetStakingRewardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStakingRewardQuery, GetStakingRewardQueryVariables>(GetStakingRewardDocument, options);
        }
export type GetStakingRewardQueryHookResult = ReturnType<typeof useGetStakingRewardQuery>;
export type GetStakingRewardLazyQueryHookResult = ReturnType<typeof useGetStakingRewardLazyQuery>;
export type GetStakingRewardQueryResult = Apollo.QueryResult<GetStakingRewardQuery, GetStakingRewardQueryVariables>;
export const GetValidatorsDocument = gql`
    query GetValidators($nominator: String!, $page: pageInputType, $sort: sortInputType, $sessionKey: String) {
  getValidators(
    nominator: $nominator
    page: $page
    sort: $sort
    sessionKey: $sessionKey
  ) {
    data {
      address
      selfBonded
      totalBonded
      nominatorCount
      commission
      myShare
      active
    }
    count
  }
}
    `;

/**
 * __useGetValidatorsQuery__
 *
 * To run a query within a React component, call `useGetValidatorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetValidatorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetValidatorsQuery({
 *   variables: {
 *      nominator: // value for 'nominator'
 *      page: // value for 'page'
 *      sort: // value for 'sort'
 *      sessionKey: // value for 'sessionKey'
 *   },
 * });
 */
export function useGetValidatorsQuery(baseOptions: Apollo.QueryHookOptions<GetValidatorsQuery, GetValidatorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetValidatorsQuery, GetValidatorsQueryVariables>(GetValidatorsDocument, options);
      }
export function useGetValidatorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetValidatorsQuery, GetValidatorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetValidatorsQuery, GetValidatorsQueryVariables>(GetValidatorsDocument, options);
        }
export type GetValidatorsQueryHookResult = ReturnType<typeof useGetValidatorsQuery>;
export type GetValidatorsLazyQueryHookResult = ReturnType<typeof useGetValidatorsLazyQuery>;
export type GetValidatorsQueryResult = Apollo.QueryResult<GetValidatorsQuery, GetValidatorsQueryVariables>;
export const ListTasksDocument = gql`
    query ListTasks($page: pageInputType, $sort: sortInputType, $taskType: String, $taskId: [Int!], $messageId: String, $phase: String, $filter: filterInputType, $sessionKey: String) {
  listTasks(
    page: $page
    sort: $sort
    taskType: $taskType
    taskId: $taskId
    messageId: $messageId
    phase: $phase
    filter: $filter
    sessionKey: $sessionKey
  ) {
    data {
      id
      taskId
      phase
      definition
      network
      hasReceived
      hasExecuted
      receivedMessageIds
      executedMessageIds
      receivedSubmitTaskId
      executedSubmitTaskId
      result
      proposed_at_block
      modified_at_block
      created_at
      updated_at
    }
    count
  }
}
    `;

/**
 * __useListTasksQuery__
 *
 * To run a query within a React component, call `useListTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useListTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListTasksQuery({
 *   variables: {
 *      page: // value for 'page'
 *      sort: // value for 'sort'
 *      taskType: // value for 'taskType'
 *      taskId: // value for 'taskId'
 *      messageId: // value for 'messageId'
 *      phase: // value for 'phase'
 *      filter: // value for 'filter'
 *      sessionKey: // value for 'sessionKey'
 *   },
 * });
 */
export function useListTasksQuery(baseOptions?: Apollo.QueryHookOptions<ListTasksQuery, ListTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListTasksQuery, ListTasksQueryVariables>(ListTasksDocument, options);
      }
export function useListTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListTasksQuery, ListTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListTasksQuery, ListTasksQueryVariables>(ListTasksDocument, options);
        }
export type ListTasksQueryHookResult = ReturnType<typeof useListTasksQuery>;
export type ListTasksLazyQueryHookResult = ReturnType<typeof useListTasksLazyQuery>;
export type ListTasksQueryResult = Apollo.QueryResult<ListTasksQuery, ListTasksQueryVariables>;
export const TaskDetailsDocument = gql`
    query TaskDetails($taskId: Int, $messageId: String, $sessionKey: String) {
  taskDetails(taskId: $taskId, messageId: $messageId, sessionKey: $sessionKey) {
    id
    taskId
    phase
    definition
    network
    hasReceived
    hasExecuted
    receivedMessageIds
    executedMessageIds
    receivedSubmitTaskId
    executedSubmitTaskId
    result
    proposed_at_block
    modified_at_block
    created_at
    updated_at
  }
}
    `;

/**
 * __useTaskDetailsQuery__
 *
 * To run a query within a React component, call `useTaskDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskDetailsQuery({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      messageId: // value for 'messageId'
 *      sessionKey: // value for 'sessionKey'
 *   },
 * });
 */
export function useTaskDetailsQuery(baseOptions?: Apollo.QueryHookOptions<TaskDetailsQuery, TaskDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaskDetailsQuery, TaskDetailsQueryVariables>(TaskDetailsDocument, options);
      }
export function useTaskDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskDetailsQuery, TaskDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaskDetailsQuery, TaskDetailsQueryVariables>(TaskDetailsDocument, options);
        }
export type TaskDetailsQueryHookResult = ReturnType<typeof useTaskDetailsQuery>;
export type TaskDetailsLazyQueryHookResult = ReturnType<typeof useTaskDetailsLazyQuery>;
export type TaskDetailsQueryResult = Apollo.QueryResult<TaskDetailsQuery, TaskDetailsQueryVariables>;
export const ListGmpMessagesDocument = gql`
    query ListGMPMessages($page: pageInputType, $sort: sortInputType, $srcTransactionHash: String, $destTransactionHash: String, $messageId: String, $phase: String, $filter: filterInputType, $sessionKey: String) {
  listGMPMessages(
    page: $page
    sort: $sort
    srcTransactionHash: $srcTransactionHash
    destTransactionHash: $destTransactionHash
    messageId: $messageId
    phase: $phase
    filter: $filter
    sessionKey: $sessionKey
  ) {
    data {
      messageId
      srcAddress
      srcBlockNumber
      srcTransactionHash
      srcNetwork
      srcEventLog
      messageReceivedTaskId
      messageExecutedTaskId
      SubmitGatewayEventTaskId
      assignedBatchId
      status
      SubmitGatewayEventTask {
        result
        batchTxHash
      }
      verified
      destBlockNumber
      destNetwork
      destTransactionHash
      destinationAddress
      destEventLog
      created_at
      updated_at
    }
    count
  }
}
    `;

/**
 * __useListGmpMessagesQuery__
 *
 * To run a query within a React component, call `useListGmpMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListGmpMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListGmpMessagesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      sort: // value for 'sort'
 *      srcTransactionHash: // value for 'srcTransactionHash'
 *      destTransactionHash: // value for 'destTransactionHash'
 *      messageId: // value for 'messageId'
 *      phase: // value for 'phase'
 *      filter: // value for 'filter'
 *      sessionKey: // value for 'sessionKey'
 *   },
 * });
 */
export function useListGmpMessagesQuery(baseOptions?: Apollo.QueryHookOptions<ListGmpMessagesQuery, ListGmpMessagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListGmpMessagesQuery, ListGmpMessagesQueryVariables>(ListGmpMessagesDocument, options);
      }
export function useListGmpMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListGmpMessagesQuery, ListGmpMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListGmpMessagesQuery, ListGmpMessagesQueryVariables>(ListGmpMessagesDocument, options);
        }
export type ListGmpMessagesQueryHookResult = ReturnType<typeof useListGmpMessagesQuery>;
export type ListGmpMessagesLazyQueryHookResult = ReturnType<typeof useListGmpMessagesLazyQuery>;
export type ListGmpMessagesQueryResult = Apollo.QueryResult<ListGmpMessagesQuery, ListGmpMessagesQueryVariables>;
export const GmpMessagesDetailsDocument = gql`
    query GMPMessagesDetails($messageId: String!, $sessionKey: String) {
  GMPMessagesDetails(messageId: $messageId, sessionKey: $sessionKey) {
    messageId
    srcAddress
    srcBlockNumber
    srcTransactionHash
    srcNetwork
    srcEventLog
    messageReceivedTaskId
    messageExecutedTaskId
    SubmitGatewayEventTaskId
    SubmitGatewayEventTask {
      batchTxHash
    }
    assignedBatchId
    status
    verified
    destBlockNumber
    destNetwork
    destTransactionHash
    destinationAddress
    destEventLog
    created_at
    updated_at
  }
}
    `;

/**
 * __useGmpMessagesDetailsQuery__
 *
 * To run a query within a React component, call `useGmpMessagesDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGmpMessagesDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGmpMessagesDetailsQuery({
 *   variables: {
 *      messageId: // value for 'messageId'
 *      sessionKey: // value for 'sessionKey'
 *   },
 * });
 */
export function useGmpMessagesDetailsQuery(baseOptions: Apollo.QueryHookOptions<GmpMessagesDetailsQuery, GmpMessagesDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GmpMessagesDetailsQuery, GmpMessagesDetailsQueryVariables>(GmpMessagesDetailsDocument, options);
      }
export function useGmpMessagesDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GmpMessagesDetailsQuery, GmpMessagesDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GmpMessagesDetailsQuery, GmpMessagesDetailsQueryVariables>(GmpMessagesDetailsDocument, options);
        }
export type GmpMessagesDetailsQueryHookResult = ReturnType<typeof useGmpMessagesDetailsQuery>;
export type GmpMessagesDetailsLazyQueryHookResult = ReturnType<typeof useGmpMessagesDetailsLazyQuery>;
export type GmpMessagesDetailsQueryResult = Apollo.QueryResult<GmpMessagesDetailsQuery, GmpMessagesDetailsQueryVariables>;
export const ListSubmitGatewayEventsTaskDocument = gql`
    query ListSubmitGatewayEventsTask($page: pageInputType, $sort: sortInputType, $taskId: [Int!], $phase: String, $batchId: [Int!], $shardId: [Int!], $filter: filterInputType, $sessionKey: String) {
  listSubmitGatewayEventsTask(
    page: $page
    sort: $sort
    taskId: $taskId
    phase: $phase
    batchId: $batchId
    shardId: $shardId
    filter: $filter
    sessionKey: $sessionKey
  ) {
    data {
      id
      taskId
      phase
      definition
      network
      message
      result
      proposed_at_block
      modified_at_block
      created_at
      updated_at
      batchTxHash
      batchId
      shardId
    }
    count
  }
}
    `;

/**
 * __useListSubmitGatewayEventsTaskQuery__
 *
 * To run a query within a React component, call `useListSubmitGatewayEventsTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useListSubmitGatewayEventsTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListSubmitGatewayEventsTaskQuery({
 *   variables: {
 *      page: // value for 'page'
 *      sort: // value for 'sort'
 *      taskId: // value for 'taskId'
 *      phase: // value for 'phase'
 *      batchId: // value for 'batchId'
 *      shardId: // value for 'shardId'
 *      filter: // value for 'filter'
 *      sessionKey: // value for 'sessionKey'
 *   },
 * });
 */
export function useListSubmitGatewayEventsTaskQuery(baseOptions?: Apollo.QueryHookOptions<ListSubmitGatewayEventsTaskQuery, ListSubmitGatewayEventsTaskQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListSubmitGatewayEventsTaskQuery, ListSubmitGatewayEventsTaskQueryVariables>(ListSubmitGatewayEventsTaskDocument, options);
      }
export function useListSubmitGatewayEventsTaskLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListSubmitGatewayEventsTaskQuery, ListSubmitGatewayEventsTaskQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListSubmitGatewayEventsTaskQuery, ListSubmitGatewayEventsTaskQueryVariables>(ListSubmitGatewayEventsTaskDocument, options);
        }
export type ListSubmitGatewayEventsTaskQueryHookResult = ReturnType<typeof useListSubmitGatewayEventsTaskQuery>;
export type ListSubmitGatewayEventsTaskLazyQueryHookResult = ReturnType<typeof useListSubmitGatewayEventsTaskLazyQuery>;
export type ListSubmitGatewayEventsTaskQueryResult = Apollo.QueryResult<ListSubmitGatewayEventsTaskQuery, ListSubmitGatewayEventsTaskQueryVariables>;
export const SubmitGatewayTaskDetailsDocument = gql`
    query SubmitGatewayTaskDetails($taskId: Int, $batchId: Int, $sessionKey: String) {
  SubmitGatewayTaskDetails(
    taskId: $taskId
    batchId: $batchId
    sessionKey: $sessionKey
  ) {
    id
    taskId
    phase
    definition
    network
    message
    result
    proposed_at_block
    modified_at_block
    created_at
    updated_at
    batchTxHash
    batchId
    shardId
    GMPMessage {
      messageId
      srcAddress
      srcBlockNumber
      srcTransactionHash
      srcNetwork
      messageReceivedTaskId
      messageExecutedTaskId
      assignedBatchId
      status
      verified
      destBlockNumber
      destNetwork
      destTransactionHash
      destinationAddress
      created_at
      updated_at
    }
  }
}
    `;

/**
 * __useSubmitGatewayTaskDetailsQuery__
 *
 * To run a query within a React component, call `useSubmitGatewayTaskDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubmitGatewayTaskDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubmitGatewayTaskDetailsQuery({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      batchId: // value for 'batchId'
 *      sessionKey: // value for 'sessionKey'
 *   },
 * });
 */
export function useSubmitGatewayTaskDetailsQuery(baseOptions?: Apollo.QueryHookOptions<SubmitGatewayTaskDetailsQuery, SubmitGatewayTaskDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubmitGatewayTaskDetailsQuery, SubmitGatewayTaskDetailsQueryVariables>(SubmitGatewayTaskDetailsDocument, options);
      }
export function useSubmitGatewayTaskDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubmitGatewayTaskDetailsQuery, SubmitGatewayTaskDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubmitGatewayTaskDetailsQuery, SubmitGatewayTaskDetailsQueryVariables>(SubmitGatewayTaskDetailsDocument, options);
        }
export type SubmitGatewayTaskDetailsQueryHookResult = ReturnType<typeof useSubmitGatewayTaskDetailsQuery>;
export type SubmitGatewayTaskDetailsLazyQueryHookResult = ReturnType<typeof useSubmitGatewayTaskDetailsLazyQuery>;
export type SubmitGatewayTaskDetailsQueryResult = Apollo.QueryResult<SubmitGatewayTaskDetailsQuery, SubmitGatewayTaskDetailsQueryVariables>;
export const NewBlocksDocument = gql`
    subscription NewBlocks {
  newBlocks {
    block {
      number
      hash
      status
      author
      parent_hash
      extrinsic_root
      extrinsic_count
      event_count
      created_at
    }
  }
}
    `;

/**
 * __useNewBlocksSubscription__
 *
 * To run a query within a React component, call `useNewBlocksSubscription` and pass it any options that fit your needs.
 * When your component renders, `useNewBlocksSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewBlocksSubscription({
 *   variables: {
 *   },
 * });
 */
export function useNewBlocksSubscription(baseOptions?: Apollo.SubscriptionHookOptions<NewBlocksSubscription, NewBlocksSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<NewBlocksSubscription, NewBlocksSubscriptionVariables>(NewBlocksDocument, options);
      }
export type NewBlocksSubscriptionHookResult = ReturnType<typeof useNewBlocksSubscription>;
export type NewBlocksSubscriptionResult = Apollo.SubscriptionResult<NewBlocksSubscription>;
export const NewExtrinsicsDocument = gql`
    subscription NewExtrinsics {
  newExtrinsics {
    id
    hash
    method
    created_at
    result
  }
}
    `;

/**
 * __useNewExtrinsicsSubscription__
 *
 * To run a query within a React component, call `useNewExtrinsicsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useNewExtrinsicsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewExtrinsicsSubscription({
 *   variables: {
 *   },
 * });
 */
export function useNewExtrinsicsSubscription(baseOptions?: Apollo.SubscriptionHookOptions<NewExtrinsicsSubscription, NewExtrinsicsSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<NewExtrinsicsSubscription, NewExtrinsicsSubscriptionVariables>(NewExtrinsicsDocument, options);
      }
export type NewExtrinsicsSubscriptionHookResult = ReturnType<typeof useNewExtrinsicsSubscription>;
export type NewExtrinsicsSubscriptionResult = Apollo.SubscriptionResult<NewExtrinsicsSubscription>;
export const NewTransferDocument = gql`
    subscription NewTransfer($isLargest: Boolean) {
  newTransfer(isLargest: $isLargest) {
    from
    id
    to
    extrinsicId
    extrinsicResult
    blockNumber
    amount
    created_at
  }
}
    `;

/**
 * __useNewTransferSubscription__
 *
 * To run a query within a React component, call `useNewTransferSubscription` and pass it any options that fit your needs.
 * When your component renders, `useNewTransferSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewTransferSubscription({
 *   variables: {
 *      isLargest: // value for 'isLargest'
 *   },
 * });
 */
export function useNewTransferSubscription(baseOptions?: Apollo.SubscriptionHookOptions<NewTransferSubscription, NewTransferSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<NewTransferSubscription, NewTransferSubscriptionVariables>(NewTransferDocument, options);
      }
export type NewTransferSubscriptionHookResult = ReturnType<typeof useNewTransferSubscription>;
export type NewTransferSubscriptionResult = Apollo.SubscriptionResult<NewTransferSubscription>;
export const NewTelemetryDocument = gql`
    subscription NewTelemetry {
  newTelemetryData {
    finalized_blocks
    active_members
    transfers
    shards_live
    total_gmpMessages
    total_accounts
    extrinsics
  }
}
    `;

/**
 * __useNewTelemetrySubscription__
 *
 * To run a query within a React component, call `useNewTelemetrySubscription` and pass it any options that fit your needs.
 * When your component renders, `useNewTelemetrySubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewTelemetrySubscription({
 *   variables: {
 *   },
 * });
 */
export function useNewTelemetrySubscription(baseOptions?: Apollo.SubscriptionHookOptions<NewTelemetrySubscription, NewTelemetrySubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<NewTelemetrySubscription, NewTelemetrySubscriptionVariables>(NewTelemetryDocument, options);
      }
export type NewTelemetrySubscriptionHookResult = ReturnType<typeof useNewTelemetrySubscription>;
export type NewTelemetrySubscriptionResult = Apollo.SubscriptionResult<NewTelemetrySubscription>;
export const AccountBalanceUpdatedDocument = gql`
    subscription AccountBalanceUpdated($address: String!) {
  accountBalanceUpdated(address: $address) {
    balance
  }
}
    `;

/**
 * __useAccountBalanceUpdatedSubscription__
 *
 * To run a query within a React component, call `useAccountBalanceUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAccountBalanceUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountBalanceUpdatedSubscription({
 *   variables: {
 *      address: // value for 'address'
 *   },
 * });
 */
export function useAccountBalanceUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<AccountBalanceUpdatedSubscription, AccountBalanceUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<AccountBalanceUpdatedSubscription, AccountBalanceUpdatedSubscriptionVariables>(AccountBalanceUpdatedDocument, options);
      }
export type AccountBalanceUpdatedSubscriptionHookResult = ReturnType<typeof useAccountBalanceUpdatedSubscription>;
export type AccountBalanceUpdatedSubscriptionResult = Apollo.SubscriptionResult<AccountBalanceUpdatedSubscription>;